import { Add, ArrowBack, AssignmentInd, Cached, Chat, Check, Clear, CloudDownload, CompareArrows, DeleteOutline, Edit, Email, InfoOutlined, ManageSearch, PictureAsPdf, QrCode2, ReportProblem, Restore, Undo, VisibilityOff, WarningAmber, WhatsApp } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Button, Card, CardContent, Grid, Link, TextField, Typography } from "@mui/material";
import { useAtom } from 'jotai';
import { FC, useEffect, useRef, useState } from "react";
import { permissionsAtom, userTypeAtom } from '../../atoms/atom';
import AppBar from "../../components/app-bar/AppBar";
import DocImage from "../../components/documentation/DocImage";
import cat2210 from '../../images/2210.png';
import event2220 from '../../images/2220.png';
import event2240 from '../../images/2240.png';
import denunciaAcompanha from '../../images/acompanha-denuncia.png';
import admission from '../../images/admission.png';
import admission1 from '../../images/admission1.png';
import admissoes from '../../images/admissoes.png';
import assinaturas from '../../images/assinaturas.png';
import audiometria from '../../images/audiometria.png';
import audiometria2 from '../../images/audiometria2.png';
import audit from '../../images/audit.png';
import canais from '../../images/canais.png';
import canalQR from '../../images/canal-qr.png';
import comparationActions from '../../images/comparation-actions.png';
import comparationAudit from '../../images/comparation-audit.png';
import comparationEvents from '../../images/comparation-events.png';
import comparationExam from '../../images/comparation-exam.png';
import comparationIgnore from '../../images/comparation-ignore.png';
import comparationIgnoredList from '../../images/comparation-ignored-list.png';
import comparationUpdate from '../../images/comparation-update.png';
import comparations from '../../images/comparations.png';
import concludeForm from '../../images/conclude-form.png';
import continueForm from '../../images/continue-form.png';
import createdOnly from '../../images/created-only.png';
import criarCanal from '../../images/criar-canal.png';
import dashboard from '../../images/dashboard.png';
import denunciaForm from '../../images/denuncia-form.png';
import denuncia from '../../images/denuncia.png';
import desconsidera2240 from '../../images/desconsidera-2240.png';
import dismissalAudit from '../../images/dismissal-audit.png';
import dismissalSgg from '../../images/dismissal-sgg.png';
import downloads from '../../images/downloads.png';
import employees from '../../images/employees.png';
import epiColaborador from '../../images/epi-colaborador.png';
import epiConfiguration from '../../images/epi-configuration.png';
import error_example from '../../images/error-example.png';
import eventsExpanded from '../../images/events-expanded.png';
import eventsOpen from '../../images/events-open.png';
import executions from '../../images/executions.png';
import extracaoEventos from '../../images/extracao-eventos.png';
import extraction_example from '../../images/extraction-example.gif';
import form1 from '../../images/form1.png';
import form2 from '../../images/form2.png';
import form3 from '../../images/form3.png';
import form4 from '../../images/form4.png';
import form from '../../images/forms.png';
import gestao from '../../images/gestao.png';
import importForm from '../../images/import-form.png';
import inicioForm from '../../images/inicio-form.png';
import inspecao from '../../images/inspecao.png';
import inspecoes from '../../images/inspecoes.png';
import itemInspecionado from '../../images/item-inspecionado.png';
import lgpd from '../../images/lgpd.png';
import link_example from '../../images/link-example.gif';
import loginForm from '../../images/login-form.png';
import naoConformidade from '../../images/nao-conformidade.png';
import newForm from '../../images/new-form.png';
import observations from '../../images/observacoes-empresa.png';
import denuncias from '../../images/painel-denuncias.png';
import painelNr06 from '../../images/painel-nr06.png';
import pendenciasExames from '../../images/pendencias-exames.png';
import positionCreateModal from '../../images/position-create-modal.png';
import positionCreateOption from '../../images/position-create-option.png';
import positionCreateSectors from '../../images/position-create-sectors.png';
import qr from '../../images/qr.png';
import resumoCiencia from '../../images/resumo-ciencia.png';
import riscoAdicionar from '../../images/risco-adicionar.png';
import riscoAlteracoes from '../../images/risco-alteracoes.png';
import riscoArvore from '../../images/risco-arvore.png';
import riscoCaSomenteLeitura from '../../images/risco-ca-somente-leitura.png';
import riscoContinuar from '../../images/risco-continuar.png';
import riscoEdicao from '../../images/risco-edicao.png';
import riscoEntregas from '../../images/risco-entregas.png';
import riscoEpiCa from '../../images/risco-epi-ca.png';
import riscoMassa from '../../images/risco-massa.png';
import riscoPainel from '../../images/risco-painel.png';
import riscoRevisao from '../../images/risco-revisao.png';
import riscoSelecao from '../../images/risco-selecao.png';
import riscoSggExportacaoEpis from '../../images/risco-sgg-exportacao-epis.png';
import riscoSubLinhas from '../../images/risco-sub-linhas.png';
import scheduleCard from '../../images/schedule-card.png';
import schedule from '../../images/schedule.png';
import scheduledIcon from '../../images/scheduled-icon.png';
import semEventos from '../../images/sem-eventos.png';
import sgg from '../../images/sgg.png';
import status from '../../images/status.png';
import supliers from '../../images/supliers.png';
import toSchedule from '../../images/to-schedule.png';
import waCreate from '../../images/wa-create.png';
import waEditTemplate from '../../images/wa-edit-template.png';
import waFilial from '../../images/wa-filial.png';
import waLate from '../../images/wa-late.png';
import waList from '../../images/wa-list.png';
import waQr from '../../images/wa-qr.png';
import waResend from '../../images/wa-resend.png';
import waSend from '../../images/wa-send.png';
import waSends from '../../images/wa-sends.png';
import waStatus from '../../images/wa-status.png';
import './Docs.scss';

const Docs: FC = () => {
	const isMounted = useRef(true);
	const [aba, setAba] = useState<string | false>('');
	const [selectedModule, setSelectedModule] = useState<string | null>(null);
	const [permissions] = useAtom(permissionsAtom);
	const [userType] = useAtom(userTypeAtom);
	const externalUser = "EXTERNO" === userType;

	const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
		setAba(isExpanded ? panel : false);
	};

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

	const modules = [
		{ id: 'INICIO', title: 'Início', description: 'Como extrair dados do eSocial.', permission: 'INICIO' },
		{ id: 'EXECUCOES', title: 'Execuções', description: 'Como analisar os dados dos funcionários extraídos do eSocial.', permission: 'EXECUTIONS' },
		{ id: 'EXECUCOES_EVENTOS', title: 'Execuções de Eventos', description: 'Como analisar os eventos dos funcionários extraídos do eSocial.', permission: 'EVENTS' },
		{ id: 'FORMULARIOS', title: 'Formulários', description: 'Como gerenciar formulários do psicossocial.', permission: 'FORMS' },
		{ id: 'CADASTRO_FUNCIONARIOS', title: 'Cadastro de Funcionários', description: 'Cadastro de funcionários e realização de agendamentos admissionais.', permission: 'EMPLOYEES' },
		{ id: 'ENVIO_DOCUMENTOS', title: 'Envio de Documentos', description: 'Envio de documentos em lote.', permission: 'DOCUMENTS'},
		{ id: 'GESTAO_DENUNCIAS', title: 'Gestão de Denúncias', description: 'Acompanhamento e gestão de denúncias.', permission: 'COMPLAINTS'},
		{ id: 'CADASTRO_AVULSO', title: 'Cadastro Avulso de Funcionário', description: 'Cadastro de funcionários e empresas não vinculados ao SGG.', permission: 'null'},
		{ id: 'AUDITORIA_ADMISSOES', title: 'Auditoria de Admissões', description: 'Auditoria e verificação de processos de admissão.', permission: 'AUDIT'},
		{ id: 'INSPECAO_EPIS', title: 'Inspeção de EPIs', description: 'Inspeção de EPIs, conformidade NR-06 e plano de ação.', permission: 'EPI_INSPECTION'},
		{ id: 'AVALIACAO_RISCOS', title: 'Avaliação de Riscos', description: 'Edição da planilha de exposições do SGG e geração da nova avaliação de riscos.', permission: 'RISK_ASSESSMENT'},
		{ id: 'FINANCEIRO', title: 'Financeiro', description: 'Acompanhamento e conferência das faturas, geração do arquivo .REM e envio dos documentos de cobrança.', permission: 'FINANCIAL'},
	];

	const renderAccordions = () => {
		switch (selectedModule) {
			case 'INICIO':
				return (
					<Accordion
						expanded={aba === 'START'}
						onChange={handleChange('START')}
						sx={{backgroundColor: "#282828", width: "75%"}}
					>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls="START"
							id="START"
							sx={{display: "flex", justifyContent: "center"}}
						>
							<Typography variant='h6'>Como extrair os dados do eSocial</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<div className="card-docs">
								<p>
									Para começar a extrair os dados do eSocial, arraste o link da
									<Link target="_blank" rel="noopener" href="/inicio"> página inicial</Link> para a sua barra de favoritos:
								</p>
								<DocImage src={link_example} />
								<p>
									<b>Observação:</b> Se você já possui o link na barra de favoritos, considere excluí-lo e adicioná-lo novamente
									para obter sempre a versão mais atualizada com correções de possíveis bugs.
								</p>
								<p>
									Em seguida, acesse o <Link target="_blank" rel="noopener" href="https://sso.acesso.gov.br/login?client_id=login.esocial.gov.br">eSocial</Link> ,
									acesse a empresa através do CPF/CNPJ e acesse a aba "Segurança e saúde no trabalho".
								</p>
								<p>Após isto, clique no extrator de dados salvo na sua barra de favoritos e aguarde a extração.</p>
								<DocImage src={extraction_example} />
								<p>
									A extração dos dados depende do funcionamento do sistema do eSocial, logo, se ocorrer alguma instabilidade
									durante o processo, será exibida uma mensagem informando que o login deve ser refeito e repetida a extração
									para que o restante dos dados sejam extraídos - exemplo abaixo:
								</p>
								<DocImage src={error_example} />
							</div>
						</AccordionDetails>
					</Accordion>
				);
			case 'EXECUCOES':
				return (
					<>
					<Accordion
						expanded={aba === 'EXTRACTIONS'}
						onChange={handleChange('EXTRACTIONS')}
						sx={{backgroundColor: "#282828", width: "75%"}}
					>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls="EXTRACTIONS"
							id="EXTRACTIONS"
							sx={{display: "flex", justifyContent: "center"}}
						>
							<Typography variant='h6'>Como analisar os dados extraídos</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<div className="card-docs">
								<p>
									Após a finalização da extração de dados do eSocial, as informações dos funcionários da empresa ficarão
									disponíveis na página de <Link target="_blank" rel="noopener" href="/execucoes">execuções</Link>.
								</p>
								<DocImage src={executions} />
								<p>Nesta página é possível ver a listagem de todas as empresas que tiveram os funcionários extraídos do eSocial:</p>
								<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
									<li>Buscar empresa pelo nome: digite o nome de uma empresa para buscá-la;</li>
									<li>Empresa: nome da empresa no SGG;</li>
									<li>Total extraído: quantidade total de funcionários extraídos do eSocial;</li>
									<li>Última execução: data e hora em que a última execução foi feita no eSocial.</li>
								</ul>
								<p>
									Cada item da lista é clicável, e quando clicada em uma empresa é aberta a página de execuções.
									Nesta página são listadas todas as filiais e matriz da empresa selecionada:
								</p>
								<DocImage src={comparations} />
								<ul style={{textAlign: "left"}}>
									<li>Filtrar funcionários: Neste seletor você pode definir quais funcionários são exibidos - Com nome divergente, ou com situação divergente, etc, ou até mesmo ver todos os funcionários;</li>
									<li>Abas: Na parte superior da listagem são exibidas as abas de execuções. Uma empresa pode ter até 3 abas, que representam execuções realizadas em determinado dia e horário;</li>
									<li>Nome da empresa: cada linha nesta listagem representa uma empresa, podendo ser uma filial ou matriz. Quando a empresa é filial, o código dela é exibido à direita do nome;</li>
									<li>Contagem de divergências: No canto direito de cada linha é exibida a contagem de quantos funcionários possuem alguma divergência conforme o filtro aplicado.</li>
								</ul>
								<p>Ao clicar em uma linha, a tabela de funcionários é expandida, revelando as informações divergentes extraídas:</p>
								<DocImage src={employees} />
								<p>
									Nesta tabela, cada linha representa um funcionário extraído do eSocial, e cada coluna representa uma informação do funcionário.
									As colunas que possuem um <Clear fontSize='small' color='error'/> indicam que há uma divergência entre este dado do funcionário
									no SGG e o campo no eSocial, enquanto as colunas que possuem um <Check fontSize='small' color='success'/> indicam que a
									informação está EXATAMENTE igual em ambas as aplicações.
								</p>
								<p>
									<b>Observação: </b>Se uma linha possui apenas o <Clear fontSize='small' color='error'/> na coluna 'Não está no eSocial', significa que
									as outras informações não foram obtidas, logo, ficarão vazias.
								</p>
							</div>
						</AccordionDetails>
					</Accordion>
					<Accordion
						expanded={aba === 'AUTOMATIC_DISMISSAL'}
						onChange={handleChange('AUTOMATIC_DISMISSAL')}
						sx={{backgroundColor: "#282828", width: "75%"}}
					>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls="AUTOMATIC_DISMISSAL"
							id="AUTOMATIC_DISMISSAL"
							sx={{display: "flex", justifyContent: "center"}}
						>
							<Typography variant='h6'>Desligamento automático de quem não está no eSocial</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<div className="card-docs">
								<p>
									Ao receber os dados de uma extração, a aplicação avalia sozinha cada funcionário marcado
									como <b>"Não está no eSocial"</b> e age conforme o tempo desde a admissão dele no SGG.
									Esta rotina é automática: <b>não depende de nenhum clique</b> e acontece a cada execução.
								</p>
								<p>
									<b>Admissão há 5 meses ou mais:</b> a aplicação registra o desligamento do funcionário no SGG
									usando <b>a própria data de admissão como data de desligamento</b>, grava uma observação no
									cadastro dele explicando o motivo e gera um registro na tela de Auditoria com o
									usuário <b>SISTEMA</b>. Nestes casos o funcionário <b>não aparece na listagem de comparações</b>,
									porque já foi tratado.
								</p>
								<p>Como fica o cadastro do funcionário no SGG depois do desligamento automático:</p>
								<DocImage src={dismissalSgg} />
								<p>E o registro correspondente na tela de Auditoria, com o usuário <b>SISTEMA</b>:</p>
								<DocImage src={dismissalAudit} />
								<p>
									<b>Admissão há menos de 5 meses:</b> nada é desligado. A aplicação apenas anota no cadastro
									que naquela data ele não constava no eSocial, no formato <i>"Não estava no eSocial em 29/08/2026"</i>.
									Essa anotação é feita <b>no máximo uma vez por mês</b> - se já houver uma anotação recente, a
									execução seguinte passa direto sem escrever de novo.
								</p>
								<p>Três situações <b>nunca</b> geram desligamento automático:</p>
								<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
									<li>Funcionário sem data de admissão preenchida no SGG;</li>
									<li>Funcionário lotado em setor cadastrado como <b>local de terceirizados</b>;</li>
									<li>
										Funcionário com as palavras <b>sócio</b>, <b>sócia</b> ou <b>proprietário(a)</b> escritas
										no campo <b>Observações adicionais</b> do cadastro. É assim que se marca quem existe no SGG
										apenas para acompanhamento interno e nunca vai constar no eSocial.
									</li>
								</ul>
								<p>
									<b>Quando o SGG recusa o desligamento:</b> a aplicação não insiste. Ela anota a recusa nas
									observações adicionais, no formato <i>"Desligamento automático não realizado em 31/08/2026"</i>
									seguido do motivo devolvido pelo SGG, e o funcionário <b>volta a aparecer na listagem de
									comparações</b> como "não está no eSocial", para que alguém decida o que fazer. Uma nova
									tentativa só acontece um mês depois, para não repetir a cada execução um desligamento que
									o SGG já recusou.
								</p>
								<p>
									<b>Atenção:</b> o desligamento é gravado direto no SGG e não é desfeito pela aplicação. Antes de
									uma execução, confira se todos os funcionários que não devem ser desligados estão com o setor
									correto ou com a observação de sócio/proprietário preenchida.
								</p>
								<p>
									Todas as anotações escritas pela aplicação começam com a marca <b>[eSocial]</b> nas observações
									adicionais, para diferenciá-las do que foi escrito por uma pessoa. O texto que já existia no campo
									nunca é apagado - a anotação é acrescentada ao final.
								</p>
							</div>
						</AccordionDetails>
					</Accordion>
					{permissions.includes('MANAGE_COMPARATIONS')
						? <>
							<Accordion
								expanded={aba === 'SYNC_SGG'}
								onChange={handleChange('SYNC_SGG')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="SYNC_SGG"
									id="SYNC_SGG"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Como atualizar as divergências no SGG</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Na última coluna da tabela de funcionários, o botão <CompareArrows fontSize='small' sx={{color: "#0085FF"}}/> abre
											o painel de atualização das divergências daquele funcionário. Por ele é possível enviar ao SGG as
											informações que o eSocial tem e o SGG não, sem precisar acessar o SGG manualmente.
										</p>
										<DocImage src={comparationUpdate} />
										<p>
											Cada linha do painel é um campo divergente, mostrando lado a lado o valor no SGG e o valor no eSocial.
											O seletor da direita marca o campo para ser atualizado. O botão "Atualizar" só aparece depois que
											ao menos um campo é marcado.
										</p>
										<p>
											<b>É permitida uma ação por atualização.</b> Ao marcar um campo, os campos que gerariam uma ação
											diferente ficam indisponíveis. Isso existe porque o SGG trata cada ação separadamente - por exemplo,
											uma transferência e uma alteração de cargo são dois registros distintos e devem ser feitas uma de cada vez.
											Os campos de dados cadastrais (nome, CPF, matrícula e datas) podem ser marcados juntos, pois são uma
											única atualização.
										</p>
										<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
											<li>Situação e Data de desligamento: são sempre marcados em conjunto, porque representam a mesma ação;</li>
											<li>Cargo e CBO: também são marcados em conjunto, pois no SGG o CBO vem do cargo e não é alterado sozinho;</li>
											<li>CBO sem divergência de cargo: fica indisponível, pois não há o que atualizar - neste caso a divergência pode ser ignorada.</li>
										</ul>
										<p>
											Antes de confirmar, o painel exibe os cards de "Ações que serão realizadas", descrevendo exatamente
											o que será feito no SGG. Enquanto a atualização é enviada, o botão fica indisponível para evitar envio duplicado.
										</p>
										<p>
											<b>Observação:</b> ao final de uma atualização bem-sucedida, o funcionário deixa de ser exibido como
											divergente na listagem. As informações são conferidas novamente na próxima extração do eSocial.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							<Accordion
								expanded={aba === 'SYNC_ACTIONS'}
								onChange={handleChange('SYNC_ACTIONS')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="SYNC_ACTIONS"
									id="SYNC_ACTIONS"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Ações disponíveis e o que cada uma exige</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											A ação executada no SGG é determinada pelos campos marcados e pelo que o eSocial informa.
											Algumas ações precisam de informações que só existem nos eventos do eSocial, e por isso
											exibem uma lista de eventos para seleção:
										</p>
										<DocImage src={comparationActions} />
										<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
											<li>
												<b>Desligamento</b> - quando a situação no eSocial é "Demitido" ou "Desligado". A data vem do
												próprio eSocial. Se houver eventos de desligamento extraídos, é necessário selecionar um para
												que o motivo seja enviado ao SGG. Sem eventos, o desligamento é registrado sem o motivo;
											</li>
											<li>
												<b>Afastamento</b> - quando a situação no eSocial é "Afastado". Exige a seleção do afastamento
												do eSocial, pois é dele que vêm a data de início e o motivo;
											</li>
											<li>
												<b>Retorno de afastamento</b> - quando o funcionário está afastado no SGG e ativo no eSocial.
												Exige duas seleções: o afastamento do eSocial que contém a data de retorno, e qual afastamento
												em aberto do SGG receberá essa data;
											</li>
											<li>
												<b>Alteração de cargo</b> - exige a seleção da movimentação trabalhista, que fornece a data da
												alteração, e a escolha do novo cargo entre os cargos do SGG que possuem o mesmo CBO do eSocial;
											</li>
											<li>
												<b>Transferência</b> - quando o local de trabalho é divergente. Exige a movimentação trabalhista
												(data da transferência) e a seleção do setor e do cargo <b><u>na empresa de destino</u></b>, já que
												cargos e setores pertencem a uma única empresa no SGG;
											</li>
											<li>
												<b>Atualização cadastral</b> - nome, CPF, matrícula, data de admissão e data de nascimento.
												Não exige seleção de evento.
											</li>
										</ul>
										<p>
											A lista de eventos é rolável na horizontal, ordenada do mais recente para o mais antigo -
											normalmente o evento desejado está entre os primeiros.
										</p>
										<p>
											<b>Observação:</b> nas ações de alteração de cargo e de transferência, a aplicação compara
											automaticamente os riscos do cargo atual com os do cargo de destino e informa ao SGG se houve
											mudança de risco. Essa comparação usa a avaliação de riscos vigente do cargo, dentro do setor do funcionário.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							<Accordion
								expanded={aba === 'EXAM_WARNING'}
								onChange={handleChange('EXAM_WARNING')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="EXAM_WARNING"
									id="EXAM_WARNING"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Aviso de exame ocupacional no desligamento</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Ao marcar os campos que resultam em desligamento, a aplicação verifica automaticamente se o
											funcionário precisa realizar um novo exame clínico demissional. Enquanto a verificação acontece,
											o botão de atualizar fica indisponível.
										</p>
										<DocImage src={comparationExam} />
										<p>A validade considerada depende do grau de risco da empresa do funcionário:</p>
										<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
											<li>Grau de risco 1 e 2: o último exame clínico vale por 135 dias;</li>
											<li>Grau de risco 3 e 4: o último exame clínico vale por 90 dias;</li>
											<li>Empresa sem grau de risco informado: é considerada a validade mais restritiva, de 90 dias.</li>
										</ul>
										<p>
											Se o último exame clínico ultrapassou a validade, ou se o funcionário não possui exame clínico
											registrado, é exibido um alerta em vermelho informando a necessidade do exame ocupacional.
										</p>
										<p>
											<b>Observação:</b> o aviso é informativo e <b><u>não impede</u></b> a atualização - a decisão
											continua sendo do usuário.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							<Accordion
								expanded={aba === 'IGNORE_DIVERGENCES'}
								onChange={handleChange('IGNORE_DIVERGENCES')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="IGNORE_DIVERGENCES"
									id="IGNORE_DIVERGENCES"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Como ignorar divergências permanentemente</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Algumas divergências não são erro e não precisam ser corrigidas - por exemplo, quando o cargo no
											SGG é "Cozinheiro júnior" e no eSocial aparece como "Cozinheiro jr". Para estes casos, o
											botão <VisibilityOff fontSize='small' sx={{color: "#dadd3eff"}}/> ao lado do botão de atualização
											permite ignorar a divergência.
										</p>
										<DocImage src={comparationIgnore} />
										<p>
											Ao marcar um campo e confirmar, a aplicação registra o par de valores - o valor no SGG e o valor no
											eSocial - e nas próximas execuções esse campo deixa de ser apontado como divergente.
										</p>
										<p>
											<b>Atenção ao alcance da regra:</b> ela vale para <b><u>todos os funcionários da empresa</u></b> enquanto
											os dois valores forem exatamente os que foram ignorados. Em campos como Situação, CBO e Local de trabalho,
											onde os valores se repetem entre funcionários, um único registro pode silenciar a mesma divergência em
											vários colaboradores.
										</p>
										<p>
											Se qualquer um dos dois valores mudar, a regra deixa de valer e a divergência volta a ser exibida.
											As regras criadas podem ser consultadas e removidas na tela de Auditoria.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							<Accordion
								expanded={aba === 'COMPARATION_AUDIT'}
								onChange={handleChange('COMPARATION_AUDIT')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="COMPARATION_AUDIT"
									id="COMPARATION_AUDIT"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Auditoria das atualizações</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											O botão "Auditoria de atualizações", no topo da tela de comparações, dá acesso ao histórico de
											tudo o que foi enviado ao SGG pela aplicação. A tela possui duas abas.
										</p>
										<p>Na aba <b>"Atualizações realizadas"</b> é registrada uma linha por informação alterada:</p>
										<DocImage src={comparationAudit} />
										<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
											<li>Data e hora, usuário que realizou, funcionário, CPF e empresa;</li>
											<li>Ação realizada e qual campo foi alterado;</li>
											<li>Valor anterior e novo valor.</li>
										</ul>
										<p>
											O nome do funcionário é um link que abre o cadastro dele no SGG. Todas as colunas são ordenáveis
											e há busca por nome ou CPF do funcionário.
										</p>
										<p>
											<b>Somente o que foi efetivamente gravado no SGG é registrado.</b> Se uma atualização enviar os
											dados cadastrais com sucesso e a ação seguinte falhar, apenas a parte concluída aparece na auditoria.
										</p>
										<p>Na aba <b>"Divergências ignoradas"</b> ficam as regras de ignorar criadas para a empresa:</p>
										<DocImage src={comparationIgnoredList} />
										<p>
											Cada linha mostra quem criou, quando, o campo e o par de valores ignorado. O botão de exclusão
											remove a regra - a partir da próxima execução, aquele campo volta a ser apontado como divergente.
										</p>
										<p>
											<b>Observação:</b> os botões de atualizar, ignorar e auditoria só ficam visíveis para usuários
											com a permissão "Atualizar e ignorar divergências das comparações", configurada em Configurações.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							<Accordion
								expanded={aba === 'CREATE_POSITION'}
								onChange={handleChange('CREATE_POSITION')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="CREATE_POSITION"
									id="CREATE_POSITION"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Criar um cargo novo a partir de um existente</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Às vezes o cargo que veio do eSocial simplesmente não existe no SGG - por exemplo,
											o funcionário passou de "Gerente operacional sr B" para "Gerente operacional sr C",
											e esse último nunca foi cadastrado. Sem ele na lista, não há como concluir a
											atualização.
										</p>
										<p>
											Para esses casos, a última opção da lista de cargos é
											<b> "Criar novo cargo a partir de um existente"</b>. Ela aparece tanto na alteração
											de cargo quanto na transferência de empresa.
										</p>
										<DocImage src={positionCreateOption} />
										<p>
											Antes de escolher o cargo é preciso escolher o setor. Cada setor da lista mostra,
											em verde, <b>quantos cargos daquele setor têm o mesmo CBO do eSocial</b> - é uma
											forma rápida de achar onde procurar. O setor onde o funcionário está hoje também
											vem destacado.
										</p>
										<DocImage src={positionCreateSectors} />
										<p>
											Ao escolher a opção de criar, abre a tela abaixo. Nela você responde duas coisas:
										</p>
										<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
											<li><b>A partir de qual cargo criar</b> - escolha o setor e o cargo que servirão de modelo;</li>
											<li><b>Em qual setor o cargo novo ficará</b> - pode ser o mesmo setor ou outro.</li>
										</ul>
										<DocImage src={positionCreateModal} />
										<p>
											O cargo novo é criado <b>com o nome que veio do eSocial</b> e copia do cargo modelo
											todo o resto: CBO, descrição das atividades, requisitos, recomendações, a
											<b> avaliação de riscos mais recente</b> e <b>todas as recomendações de exame</b>.
											A ideia é que o cargo novo fique igual ao modelo, mudando apenas o nome.
										</p>
										<p>
											Por isso a lista de cargos modelo mostra <b>somente os cargos com o mesmo CBO do
											eSocial</b>: como o CBO é copiado do modelo, escolher um cargo de CBO diferente
											geraria um cargo que não serve para a atualização.
										</p>
										<p>
											Depois de criar, a lista é recarregada e o cargo novo já aparece selecionado,
											pronto para você concluir a atualização
										</p>
										<p>
											<b>Pontos de atenção:</b>
										</p>
										<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
											<li>
												Se já existir um cargo com esse nome no setor escolhido, a criação é recusada -
												nesse caso o cargo já está na lista e basta selecioná-lo;
											</li>
											<li>
												A criação é gravada na tela de Auditoria, com o seu usuário, para ficar registrado
												quem criou o cargo e a partir de qual setor;
											</li>
											<li>
												O cargo é criado direto no SGG e a aplicação não desfaz. Se a cópia da avaliação de
												riscos ou das recomendações de exame falhar, a mensagem avisa o que não foi copiado
												e essa parte precisa ser completada no SGG.
											</li>
										</ul>
									</div>
								</AccordionDetails>
							</Accordion>
						</>
						: <></>
					}
					</>
				);
			case 'EXECUCOES_EVENTOS':
				return (
					<>
						<Accordion
							expanded={aba === 'EVENTS_EXTRACTION'}
							onChange={handleChange('EVENTS_EXTRACTION')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="EVENTS_EXTRACTION"
								id="EVENTS_EXTRACTION"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Como extrair os eventos do eSocial</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										A extração de eventos usa um link próprio, diferente do extrator de dados dos funcionários.
										Na <Link target="_blank" rel="noopener" href="/inicio">página inicial</Link>, arraste o
										link <b>"Extrator de eventos do eSocial"</b> para a sua barra de favoritos
									</p>
									<p>
										Em seguida, acesse o eSocial, entre na empresa pelo CPF/CNPJ, abra a aba "Segurança e saúde
										no trabalho" e clique no extrator de eventos salvo na barra de favoritos. Aguarde até o fim
										da extração.
									</p>
									<p>
										O extrator busca no eSocial os contratos dos funcionários da empresa e, de cada contrato,
										os eventos de Segurança e Saúde no Trabalho:
									</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>S-2210</b> - Comunicação de Acidente de Trabalho (CAT);</li>
										<li><b>S-2220</b> - Monitoramento da Saúde do Trabalhador (ASO);</li>
										<li><b>S-2240</b> - Condições Ambientais do Trabalho - Agentes Nocivos.</li>
									</ul>
									<p>
										Assim que os eventos chegam, a aplicação aplica as regras de validação de cada tipo e
										guarda o resultado. O que aparece na tela é sempre o retrato do eSocial <b>no momento da
										extração</b> - depois de corrigir um evento no eSocial, é preciso extrair novamente para
										ver o resultado atualizado.
									</p>
									<p>
										<b>Extração interrompida:</b> se a extração parar no meio, por exemplo por queda da sessão
										do eSocial, basta clicar no extrator de novo <b>no mesmo dia</b>: a aplicação continua de
										onde parou, buscando apenas os funcionários que ainda faltam. Em outro dia, ou depois de
										uma extração completa, é iniciada uma execução nova, com todos os funcionários.
									</p>
									<p>
										<b>Observação:</b> a aplicação guarda somente as <b>duas execuções mais recentes</b> de
										cada empresa. Ao concluir uma nova extração, a mais antiga delas é apagada.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'EVENTS_EXECUTIONS'}
							onChange={handleChange('EVENTS_EXECUTIONS')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="EVENTS_EXECUTIONS"
								id="EVENTS_EXECUTIONS"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Listagem de execuções de eventos</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										Ao final da extração, a empresa passa a aparecer na página
										de <Link target="_blank" rel="noopener" href="/execucoes-eventos">execuções de eventos</Link>,
										que mostra a execução mais recente de cada empresa:
									</p>
									<DocImage src={extracaoEventos} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>Buscar empresa pelo nome: digite o nome de uma empresa para buscá-la;</li>
										<li>
											Empresa: nome da empresa no SGG. Empresas cadastradas em Configurações, na aba "Empresas
											externas", aparecem com a marcação <b>(externa)</b>;
										</li>
										<li>CNPJ matriz: o botão ao lado copia o CNPJ;</li>
										<li>
											Total extraído: quantos funcionários já foram extraídos em relação ao total da empresa.
											Fica em verde quando todos foram extraídos e em vermelho quando a extração ficou incompleta.
											Empresa sem funcionários ativos mostra "Nenhum funcionário ativo";
										</li>
										<li>Última execução: data e hora da extração mais recente;</li>
										<li>
											Status: "Possui divergências" quando ao menos um funcionário tem irregularidade em algum
											evento S-2210, S-2220 ou S-2240, ou "Sem divergências". Funcionários que não estão no
											eSocial não entram nessa conta;
										</li>
										<li>Grau de risco: grau de risco da empresa, usado na validação dos exames do S-2220.</li>
									</ul>
									<p>
										As colunas Empresa, Total extraído, Última execução, Status e Grau de risco podem ser
										ordenadas clicando no título. Clicar no nome da empresa abre a análise dos eventos dela.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'EVENTS_COMPARATIONS'}
							onChange={handleChange('EVENTS_COMPARATIONS')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="EVENTS_COMPARATIONS"
								id="EVENTS_COMPARATIONS"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Como analisar os eventos de uma empresa</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										Ao abrir uma empresa, o topo da página mostra o nome dela e o grau de risco considerado nas
										validações. Logo abaixo ficam os controles da análise:
									</p>
									<DocImage src={comparationEvents} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>Buscar funcionário pelo nome: digite o nome de um funcionário para buscá-lo;</li>
										<li>Filtrar funcionários: define quais funcionários são exibidos - as opções estão descritas abaixo;</li>
										<li>Abas: cada aba é uma execução, identificada pela data e hora. A mais recente vem selecionada;</li>
										<li>
											Baixar relatório: o botão <CloudDownload fontSize='small' color='success'/> gera a planilha
											com o resultado da execução da aba selecionada;
										</li>
										<li>Total de trabalhadores no eSocial: quantidade de trabalhadores que o próprio eSocial informa para o empregador.</li>
									</ul>
									<p>As opções do filtro são:</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>Alguma divergência</b> (padrão): funcionários com irregularidade em pelo menos um dos três eventos;</li>
										<li><b>Erro em 2210</b>, <b>Erro em 2220</b> e <b>Erro em 2240</b>: apenas quem tem irregularidade naquele evento;</li>
										<li><b>Não está no eSocial</b> e <b>Admissão preliminar</b>: as situações descritas em "Situações que não passam pela validação";</li>
										<li><b>Ver todos os funcionários</b>.</li>
									</ul>
									<p>
										<b>Atenção:</b> o filtro padrão mostra apenas irregularidades de eventos. Funcionários que não
										estão no eSocial ou que estão com admissão preliminar <b><u>não aparecem</u></b> nele - para
										vê-los, use o filtro correspondente ou "Ver todos os funcionários".
									</p>
									<p>
										A listagem é agrupada por empresa - matriz e filiais, conforme o local de trabalho do contrato
										no eSocial. À direita de cada empresa aparece quantos funcionários têm divergência. Ao clicar
										em uma empresa, a tabela de funcionários é expandida:
									</p>
									<DocImage src={eventsExpanded} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>
											Funcionário: nome no eSocial. A marcação <b>(sem vínculo)</b> indica trabalhador cadastrado
											no eSocial sem vínculo de emprego - os eventos dele são validados normalmente;
										</li>
										<li>CPF;</li>
										<li>Eventos 2210, Eventos 2220 e Eventos 2240: resultado da validação de cada evento;</li>
										<li>
											Não está no eSocial e Admissão preliminar: marcadas com <Clear fontSize='small' color='error'/> quando
											o funcionário está em uma dessas situações.
										</li>
									</ul>
									<p>Nas colunas de eventos:</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><Check fontSize='small' color='success'/> o funcionário tem eventos daquele tipo e nenhuma irregularidade foi encontrada;</li>
										<li><InfoOutlined fontSize='small' color='error'/> foi encontrada ao menos uma irregularidade;</li>
										<li>
											"Nenhum": não há evento daquele tipo. No S-2210 isso não é divergência, já que só existe
											CAT quando houve acidente. No S-2220 e no S-2240 o texto aparece em vermelho e <b>conta
											como divergência</b>, porque a aplicação espera esses eventos em todo contrato.
										</li>
									</ul>
									<p>
										<b>Observação:</b> um funcionário com mais de um contrato no eSocial aparece uma vez para cada
										contrato, cada linha com os eventos e as validações daquele contrato.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'EVENTS_DETAILS'}
							onChange={handleChange('EVENTS_DETAILS')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="EVENTS_DETAILS"
								id="EVENTS_DETAILS"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Detalhes dos eventos de um funcionário</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										Clicar no <Check fontSize='small' color='success'/> ou no <InfoOutlined fontSize='small' color='error'/> abre
										a janela com os eventos daquele tipo extraídos do eSocial para o contrato:
									</p>
									<DocImage src={eventsOpen} />
									<p>
										No topo, cada irregularidade encontrada aparece em um aviso vermelho com a descrição do problema.
										Abaixo vêm a data de admissão, a data de demissão (quando houver) e a lista de eventos, com as
										informações usadas na validação:
									</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>S-2210:</b> data do acidente e data de envio do evento ao eSocial;</li>
										<li><b>S-2220:</b> data do exame e tipo - Admissional, Periódico, Retorno, Mudança de função, Monitoração pontual ou Demissional;</li>
										<li><b>S-2240:</b> data de início da condição, se a descrição das atividades está preenchida e os agentes nocivos informados.</li>
									</ul>
									<p>
										<b>Observação:</b> a data de envio do S-2210 não é um campo do evento - ela é lida do
										identificador do evento no eSocial.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'EVENTS_2210'}
							onChange={handleChange('EVENTS_2210')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="EVENTS_2210"
								id="EVENTS_2210"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>O que é verificado no S-2210 (CAT)</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>Cada CAT enviada no contrato passa pelas verificações abaixo:</p>
									<DocImage src={cat2210} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>
											<b>Prazo de envio:</b> o evento precisa ser enviado entre o dia do acidente e o dia útil
											seguinte. Acidente na sexta-feira ou no sábado tem prazo até a segunda-feira. Feriados não
											são considerados. Fora disso: <i>"Acidente do dia 15/03/2024 enviado fora do prazo"</i>;
										</li>
										<li>
											<b>Data de envio ilegível:</b> quando não é possível ler a data de envio no identificador do
											evento, o prazo não é verificado e o evento é apontado como <i>"Erro ao verificar data de
											envio do evento do dia 15/03/2024"</i>;
										</li>
										<li>
											<b>Acidentes no mesmo dia:</b> dois eventos com a mesma data de acidente são apontados
											como <i>"Existem eventos cadastrados com o mesmo dia de acidente"</i>.
										</li>
									</ul>
									<p>Funcionário sem nenhum S-2210 não tem divergência neste evento.</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'EVENTS_2220'}
							onChange={handleChange('EVENTS_2220')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="EVENTS_2220"
								id="EVENTS_2220"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>O que é verificado no S-2220 (ASO)</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>Os exames do contrato são analisados em ordem de data. As verificações são:</p>
									<DocImage src={event2220} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>Nenhum exame:</b> funcionário sem nenhum S-2220 é divergente;</li>
										<li>
											<b>Exame admissional:</b> o contrato precisa ter um. Sem ele: <i>"Funcionário não possui
											nenhum exame admissional no contrato"</i>;
										</li>
										<li>
											<b>Data do admissional:</b> precisa ser anterior à data de admissão - exame feito no próprio
											dia da admissão também é apontado: <i>"Exame admissional não é anterior à admissão"</i>;
										</li>
										<li>
											<b>Intervalo entre exames:</b> dois exames seguidos, sem contar o demissional, não podem ter
											1 ano ou mais de diferença: <i>"ASO de 10/02/2022 e 15/03/2023 possuem 1 ano ou mais de diferença"</i>;
										</li>
										<li>
											<b>Funcionário ativo:</b> o último exame não pode ter 1 ano ou mais: <i>"O último ASO
											(10/02/2023) venceu há mais de 1 ano!"</i>;
										</li>
										<li>
											<b>Desligado com exame demissional:</b> o último exame anterior ao demissional não pode ter
											1 ano ou mais de diferença para ele: <i>"Funcionário tem ASO faltante antes da demissão -
											demissão a mais de um ano do último ASO cadastrado"</i>;
										</li>
										<li>
											<b>Desligado sem exame demissional:</b> só é apontado quando o último exame já tinha passado
											da validade na data do desligamento - 135 dias para empresas de grau de risco 1 e 2, e 90 dias
											para grau 3 e 4: <i>"Funcionário demitido há mais de 90 dias após o último ASO cadastrado e
											não possui exame demissional"</i>.
										</li>
									</ul>
									<p>
										<b>Observação:</b> o intervalo de 1 ano é fixo na aplicação e não acompanha a periodicidade
										definida no PCMSO de cada função. No funcionário desligado sem exame demissional, apenas a
										regra de validade acima é aplicada - o intervalo entre os exames anteriores não é verificado.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'EVENTS_2240'}
							onChange={handleChange('EVENTS_2240')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="EVENTS_2240"
								id="EVENTS_2240"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>O que é verificado no S-2240 (condições ambientais)</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>Os eventos de condições ambientais do contrato passam pelas verificações abaixo:</p>
									<DocImage src={event2240} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>Nenhum evento:</b> funcionário sem nenhum S-2240 é divergente;</li>
										<li>
											<b>Descrição das atividades:</b> todo evento precisa ter a descrição preenchida: <i>"Existem
											eventos sem descrição das atividades preenchidas"</i>;
										</li>
										<li>
											<b>Agentes nocivos:</b> todo evento precisa informar ao menos um agente: <i>"Existem eventos
											sem agentes nocivos informados"</i>;
										</li>
										<li>
											<b>Admitido a partir de 10/01/2022:</b> precisa existir um evento com data de início igual à
											data de admissão: <i>"Funcionário não possui evento com data de início igual à admissão"</i>;
										</li>
										<li>
											<b>Admitido antes de 10/01/2022:</b> precisa existir um evento com data de início exatamente
											em 10/01/2022: <i>"Funcionário admitido antes de 10/01/2022, mas não possui 2240 com esta
											data de início"</i>.
										</li>
									</ul>
									<p>
										<b>Observação:</b> a última regra pode ser desligada por empresa, em Configurações, na aba
										"Extração de eventos". Nas empresas cadastradas ali, quem foi admitido antes de 10/01/2022 não
										precisa do evento com essa data - as demais regras continuam valendo.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'EVENTS_SPECIAL_CASES'}
							onChange={handleChange('EVENTS_SPECIAL_CASES')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="EVENTS_SPECIAL_CASES"
								id="EVENTS_SPECIAL_CASES"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Situações que não passam pela validação</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>Alguns funcionários não têm os eventos validados e aparecem na tabela de forma diferente:</p>
									<DocImage src={semEventos} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>
											<b>Não está no eSocial:</b> o CPF consta no SGG, mas nenhum contrato foi encontrado no
											eSocial. O nome exibido é o do SGG, e a linha mostra apenas o <Clear fontSize='small' color='error'/> na
											coluna "Não está no eSocial";
										</li>
										<li>
											<b>Admissão preliminar:</b> o eSocial tem apenas a admissão preliminar do contrato, por isso
											os eventos não são consultados. A linha mostra o <Clear fontSize='small' color='error'/> na
											coluna "Admissão preliminar";
										</li>
										<li>
											<b>Funcionário ignorado:</b> contrato com data de desligamento anterior a 10/01/2022. No lugar
											dos eventos, a linha mostra <i>"Funcionário ignorado. Data de desligamento inferior a 10/01/2022"</i>.
											Esses funcionários aparecem apenas no filtro "Ver todos os funcionários".
										</li>
									</ul>
									<p>
										Nenhuma dessas situações conta como divergência no Status da listagem de execuções nem no
										filtro "Alguma divergência". No relatório, apenas os funcionários que não estão no eSocial
										entram no plano de ação.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'EVENTS_REPORT'}
							onChange={handleChange('EVENTS_REPORT')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="EVENTS_REPORT"
								id="EVENTS_REPORT"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Relatório de eventos</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										O botão <CloudDownload fontSize='small' color='success'/> no topo da análise baixa uma planilha
										Excel com o resultado da execução da aba selecionada, com o nome "Relatório de eventos do
										eSocial" seguido do nome da empresa. A planilha tem cinco abas:
									</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>
											<b>Painel Geral:</b> empresa, CNPJ, a data de 10/01/2022 usada como início da condição, e a
											quantidade de matrículas avaliadas, de pendências em cada evento e de funcionários sem
											registro no eSocial;
										</li>
										<li>
											<b>Controle Individual:</b> uma linha por funcionário, com a situação de cada evento (Regular
											ou Irregular), a descrição das irregularidades e as datas usadas na validação - acidente,
											envio, admissão, demissão, exames e condições ambientais;
										</li>
										<li>
											<b>Plano de Ação:</b> uma linha para cada irregularidade encontrada, com o evento, o problema e
											o status "Pendente". As colunas Responsável, Prazo e DT Prevista vêm em branco para serem
											preenchidas;
										</li>
										<li><b>Histórico:</b> modelo em branco para registrar as correções feitas;</li>
										<li><b>Base Legal:</b> o prazo ou regra geral e a referência de cada evento.</li>
									</ul>
									<p>
										<b>Observação:</b> o plano de ação não inclui funcionários sem irregularidade, ignorados ou com
										admissão preliminar. Quem não está no eSocial entra com o problema "Não consta no eSocial".
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						{permissions.includes('SETTINGS')
							? <Accordion
								expanded={aba === 'EVENTS_IGNORE_2240'}
								onChange={handleChange('EVENTS_IGNORE_2240')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="EVENTS_IGNORE_2240"
									id="EVENTS_IGNORE_2240"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Desconsiderar a data de 10/01/2022 no S-2240</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Em Configurações, a aba <b>"Extração de eventos"</b> lista as empresas que não precisam ter
											o S-2240 com início em 10/01/2022 para os funcionários admitidos antes dessa data.
										</p>
										<DocImage src={desconsidera2240} />
										<p>
											Para incluir uma empresa, informe o CNPJ da matriz - o mesmo exibido na coluna "CNPJ matriz"
											da listagem de execuções de eventos - e clique em "Adicionar". Para remover, clique no
											<b> x</b> da empresa na lista.
										</p>
										<p>
											<b>Atenção:</b> a configuração vale a partir da <b>próxima extração</b>. As execuções já
											feitas continuam exibindo o resultado calculado na época - para aplicar a mudança, extraia os
											eventos da empresa novamente.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
					</>
				);
			case 'FORMULARIOS':
				return (
					<>
						<Accordion
							expanded={aba === 'FORMS_OVERVIEW'}
							onChange={handleChange('FORMS_OVERVIEW')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="FORMS_OVERVIEW"
								id="FORMS_OVERVIEW"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Visão geral do módulo</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										O módulo de <b>Formulários</b> aplica o questionário COPSOQ II de avaliação de riscos
										psicossociais. Cada formulário pertence a uma empresa, identificada pelo CPF/CNPJ, e é
										respondido pelos funcionários dela no celular ou no computador, através de um link ou QR code.
									</p>
									<p>O fluxo segue sempre a mesma sequência:</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>Um formulário é criado para o CPF/CNPJ da empresa;</li>
										<li>O link ou o QR code é repassado aos funcionários;</li>
										<li>Cada funcionário entra com o CPF e um segundo identificador e responde o questionário;</li>
										<li>A quantidade de respostas é acompanhada na lista e, ao fim da coleta, o formulário é concluído;</li>
										<li>Os resultados são baixados em planilhas: respostas, diagnóstico de riscos psicossociais e inventário de riscos.</li>
									</ul>
									<p>
										<b>Atenção:</b> depois de criado, o formulário <b><u>não pode ser editado nem excluído</u></b>.
										Se o CPF/CNPJ ou o segundo identificador estiverem errados, crie um formulário novo.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'FORMS_LIST'}
							onChange={handleChange('FORMS_LIST')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="FORMS_LIST"
								id="FORMS_LIST"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Listagem de formulários</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										A página de <Link target="_blank" rel="noopener" href="/formularios">formulários</Link> lista
										os formulários das empresas que você pode acessar:
									</p>
									<DocImage src={form} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>
											Buscar por nome ou CPF/CNPJ: filtra pelo nome da empresa ou pelo CPF/CNPJ. O CPF/CNPJ
											precisa ser digitado com a pontuação, como aparece na lista;
										</li>
										<li>Filtrar formulários: "Abertos" (padrão), "Concluídos" ou "Todos";</li>
										<li>Empresa: nome da empresa no SGG, seguido do código dela no SGG;</li>
										<li>CNPJ: o CPF/CNPJ informado na criação do formulário;</li>
										<li>Data de criação e Data de conclusão;</li>
										<li>Respostas concluídas: detalhado em "Acompanhar as respostas";</li>
										<li>Status: "Aberto" ou "Concluído".</li>
									</ul>
									<p>
										Na coluna Ações, o botão <QrCode2 fontSize='small' color='warning'/> abre o QR code do
										formulário - desabilitado nos formulários concluídos - e o
										botão <InfoOutlined fontSize='small' color='info'/> abre os detalhes, de onde saem as
										planilhas e as demais ações.
									</p>
									<p>As colunas Data de criação e Data de conclusão podem ser ordenadas clicando no título.</p>
									<p>
										<b>Observação:</b> usuários externos veem apenas os formulários das empresas liberadas para
										a conta deles.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						{permissions.includes('CREATE_FORMS')
							? <Accordion
								expanded={aba === 'FORMS_CREATE'}
								onChange={handleChange('FORMS_CREATE')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="FORMS_CREATE"
									id="FORMS_CREATE"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Criar um formulário</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>O botão <b>"Novo formulário"</b> abre a criação, que tem apenas dois campos:</p>
										<DocImage src={newForm} />
										<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
											<li><b>CPF/CNPJ:</b> documento da empresa, que precisa estar cadastrada no SGG;</li>
											<li><b>Segundo identificador:</b> o dado que o funcionário informa, junto com o CPF, para entrar no questionário.</li>
										</ul>
										<p>As opções de segundo identificador são:</p>
										<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
											<li><b>Matrícula</b> (padrão): a matrícula do funcionário no SGG;</li>
											<li><b>Código RH:</b> o código RH do funcionário no SGG;</li>
											<li><b>Código do funcionário no SGG:</b> o código interno do funcionário no SGG;</li>
											<li><b>Data de nascimento:</b> a data de nascimento cadastrada no SGG, digitada no formato dd/mm/aaaa.</li>
										</ul>
										<p>
											Na tela de entrada do funcionário, as opções Código RH e Código do funcionário no SGG
											aparecem com o nome <b>"Identificador"</b> - informe aos funcionários qual código usar.
										</p>
										<p>
											Podem responder os funcionários com situação <b>Ativo</b> no SGG cuja empresa tem exatamente
											o CPF/CNPJ do formulário. Matriz e filiais <b>não são somadas</b>: cada CNPJ precisa do
											próprio formulário.
										</p>
										<p>
											<b>Observação:</b> não há limite de formulários por empresa - é possível criar mais de um
											para o mesmo CPF/CNPJ. Se o formulário não aparecer na lista depois de salvar, confira se o
											CPF/CNPJ está cadastrado como empresa no SGG.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
						<Accordion
							expanded={aba === 'FORMS_SHARE'}
							onChange={handleChange('FORMS_SHARE')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="FORMS_SHARE"
								id="FORMS_SHARE"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Compartilhar o formulário</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>O botão <QrCode2 fontSize='small' color='warning'/> da lista abre o QR code do formulário:</p>
									<DocImage src={qr} />
									<p>
										O funcionário pode escanear o QR code com o celular ou acessar o link exibido logo abaixo, no
										formato <i>copsoq2.inovação.seg.br/número-do-formulário/login</i>. O botão "Baixar imagem do
										QR Code" salva a imagem para impressão ou divulgação, e o ícone ao lado do link copia o endereço.
									</p>
									<p>
										<b>Observação:</b> a aplicação não envia o link por e-mail nem por WhatsApp - a divulgação aos
										funcionários é feita por fora.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'FORMS_RESPONDENT'}
							onChange={handleChange('FORMS_RESPONDENT')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="FORMS_RESPONDENT"
								id="FORMS_RESPONDENT"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Como o funcionário responde</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										Ao abrir o link, o funcionário informa o CPF e o segundo identificador definido na criação
										do formulário:
									</p>
									<DocImage src={loginForm} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>Dados que não conferem com o SGG, ou funcionário sem situação Ativo, recebem a mensagem "Dados inválidos.";</li>
										<li>Formulário concluído mostra a mensagem "Formulário indisponível".</li>
									</ul>
									<p>
										Depois da entrada vêm uma página de apresentação e as perguntas, uma por vez, com o
										percentual de progresso:
									</p>
									<DocImage src={inicioForm} />
									<DocImage src={continueForm} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>
											As primeiras perguntas traçam o perfil do funcionário, como faixa etária, sexo, escolaridade
											e tempo de empresa. A descrição da deficiência só é perguntada a quem responde "SIM" para PCD;
										</li>
										<li>Antes do bloco de percepção dos riscos, e de novo a cada mudança de escala, aparece uma página com as orientações de resposta;</li>
										<li>As duas perguntas abertas do final são opcionais;</li>
										<li>A última pergunta é a declaração de ciência, e o botão "Finalizar" encerra o questionário.</li>
									</ul>
									<p>
										Cada resposta é gravada assim que o funcionário avança. Se ele fechar a página no meio, ao
										entrar de novo continua de onde parou. Quem já concluiu o questionário não consegue responder
										de novo.
									</p>
									<p>As respostas são gravadas com o setor e a função do funcionário no SGG, sem o nome.</p>
									<p>
										<b>Atenção em aparelho compartilhado:</b> o acesso fica salvo no navegador. Se uma pessoa parar
										no meio, a próxima que abrir o link no mesmo aparelho continua o questionário dela. Cada pessoa
										deve responder até o fim e tocar em "Iniciar nova resposta" antes de passar o aparelho adiante.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'FORMS_PROGRESS'}
							onChange={handleChange('FORMS_PROGRESS')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="FORMS_PROGRESS"
								id="FORMS_PROGRESS"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Acompanhar as respostas</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										A coluna <b>Respostas concluídas</b> mostra dois números, no
										formato <i>respondidos/total</i>:
									</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>
											O primeiro é a quantidade de questionários finalizados. Depois de uma importação, passa a
											contar também as respostas importadas e os questionários ainda em andamento;
										</li>
										<li>
											O segundo é a quantidade de funcionários da empresa no SGG que não estão com situação
											"Demitido", recalculada sempre que a lista é aberta.
										</li>
									</ul>
									<p>
										<b>Observação:</b> funcionários com situação diferente de Ativo e de Demitido entram no total,
										mas não conseguem entrar no questionário - por isso o total pode não ser alcançado. A aplicação
										não mostra quem já respondeu.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						{permissions.includes('CONCLUDE_FORMS')
							? <Accordion
								expanded={aba === 'FORMS_CONCLUDE'}
								onChange={handleChange('FORMS_CONCLUDE')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="FORMS_CONCLUDE"
									id="FORMS_CONCLUDE"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Concluir e reabrir um formulário</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Na janela de detalhes, o botão <b>"Concluir formulário"</b> encerra a coleta
											e <b>"Reabrir formulário"</b> volta a abri-la. A ação é imediata, sem confirmação.
										</p>
										<DocImage src={concludeForm} />
										<p>
											Ao concluir, o formulário recebe a data de conclusão, o QR code fica desabilitado e a página
											de entrada passa a mostrar "Formulário indisponível". As respostas são mantidas e as planilhas
											continuam disponíveis. Ao reabrir, a data de conclusão é apagada e o link volta a funcionar.
										</p>
										<p>
											<b>Observação:</b> quem já tinha entrado no questionário antes da conclusão ainda consegue
											terminar de responder.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
						<Accordion
							expanded={aba === 'FORMS_RESULTS'}
							onChange={handleChange('FORMS_RESULTS')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="FORMS_RESULTS"
								id="FORMS_RESULTS"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Planilhas de resultados e de riscos psicossociais</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										A janela de detalhes (<InfoOutlined fontSize='small' color='info'/>) mostra o segundo
										identificador do formulário e os botões de download. As planilhas consideram apenas os
										questionários <b>finalizados</b>.
									</p>
									<DocImage src={concludeForm} />
									<p>
										<b>"Baixar planilha de resultados"</b> gera o arquivo "COPSOQ II" da empresa, com uma linha por
										funcionário: data, empresa, setor, função e a resposta de cada pergunta.
									</p>
									<p>
										<b>"Baixar planilha de Riscos psicossociais"</b> gera o "DIAGNÓSTICO DE RISCOS PSICOSSOCIAIS",
										que calcula a pontuação de cada dimensão do COPSOQ II e a classifica em três faixas:
									</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>0 a 49% - risco baixo:</b> situação favorável, monitorar;</li>
										<li><b>50 a 74% - risco moderado:</b> situação intermediária, planejar ações corretivas;</li>
										<li><b>75 a 100% - risco alto:</b> situação crítica, intervenção imediata.</li>
									</ul>
									<p>
										<b>Observação:</b> na aba "Relatório" dessa planilha, os campos do cabeçalho - unidade avaliada,
										período de avaliação, avaliado por, número de respondentes, entre outros - vêm em branco e
										devem ser preenchidos manualmente.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'FORMS_INVENTORY'}
							onChange={handleChange('FORMS_INVENTORY')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="FORMS_INVENTORY"
								id="FORMS_INVENTORY"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Inventário de riscos e downloads</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										A <b>"Baixar planilha de Inventário de riscos"</b> é gerada em segundo plano, por ser mais
										demorada. Ao clicar, a janela fecha e aparece a mensagem "Acompanhe o download do arquivo no
										botão de downloads".
									</p>
									<p>
										O botão <b>"Downloads"</b>, no topo da lista de formulários, mostra os arquivos prontos e se
										atualiza sozinho a cada poucos segundos. Cada arquivo tem o botão "Baixar":
									</p>
									<DocImage src={downloads} />
									<p>
										Para cada setor e função, a aplicação calcula a pontuação dos 29 fatores de risco psicossocial
										a partir da média das respostas. Todo fator com pontuação <b>acima de 50%</b> entra na aba
										"Análise Preliminar" do inventário, do mais alto para o mais baixo, e cada função ganha uma aba
										de relatório própria. Gravidade, probabilidade, classificação e prioridade são calculadas pelas
										fórmulas da própria planilha.
									</p>
									<p>Inventários grandes são divididos em mais de um arquivo ("Arquivo 1", "Arquivo 2"...).</p>
									<p><b>Pontos de atenção:</b></p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>Os arquivos ficam disponíveis só até a próxima reinicialização do servidor - baixe assim que ficarem prontos;</li>
										<li>Se o arquivo não aparecer em Downloads depois de alguns minutos, a geração falhou sem mensagem de erro;</li>
										<li>
											A coluna "Quantidade de Colaboradores" mostra quantos funcionários responderam naquele setor e
											função, não o total de funcionários do setor;
										</li>
										<li>Os prazos (Mês / Ano) do plano de ação vêm fixos no modelo da planilha e devem ser revisados;</li>
										<li>Usuários externos veem em Downloads apenas os arquivos das empresas liberadas para a conta deles.</li>
									</ul>
								</div>
							</AccordionDetails>
						</Accordion>
						{permissions.includes('IMPORT_FORMS')
							? <Accordion
								expanded={aba === 'FORMS_IMPORT'}
								onChange={handleChange('FORMS_IMPORT')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="FORMS_IMPORT"
									id="FORMS_IMPORT"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Importar respostas</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Respostas coletadas fora do questionário online podem ser incluídas no formulário pelo
											botão <b>"Importar respostas"</b> da janela de detalhes:
										</p>
										<DocImage src={importForm} />
										<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
											<li>
												Baixe o modelo em "Baixar modelo de planilha para respostas" e preencha uma linha por
												funcionário, sem alterar as colunas nem o nome da aba;
											</li>
											<li>Escolha o arquivo em "Escolher arquivo com respostas (.xlsx)" e clique em "Importar".</li>
										</ul>
										<p>
											A leitura para na primeira linha com a coluna "EMPRESA:" vazia. Setor ou função em branco são
											gravados como "erro". As respostas importadas entram nas planilhas como as respostas online, e
											a importação é aceita mesmo em formulário concluído.
										</p>
										<p><b>Pontos de atenção:</b></p>
										<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
											<li>Importar o mesmo arquivo duas vezes duplica as respostas - não há verificação de repetição;</li>
											<li>Use arquivo .xlsx: arquivos .xls aparecem na seleção, mas não são lidos;</li>
											<li>
												A mensagem "Respostas importadas com sucesso!" aparece mesmo quando o arquivo não pôde ser
												lido. Confira a coluna Respostas concluídas depois de importar.
											</li>
										</ul>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
					</>
				);
			case 'CADASTRO_FUNCIONARIOS':
				return (
					<>
						<Accordion
							expanded={aba === 'EMPLOYEE_FORM'}
							onChange={handleChange('EMPLOYEE_FORM')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="EMPLOYEE_FORM"
								id="EMPLOYEE_FORM"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Cadastro de funcionários</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										No módulo de <Link target="_blank" rel="noopener" href="/cadastro-funcionarios">cadastro de funcionários</Link> é
										possível cadastrar um novo funcionário para uma empresa. O preenchimento começa pela empresa e
										pelo CPF da pessoa a ser cadastrada, e segue as regras abaixo:
									</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>Empresa: usuários internos podem digitar o CNPJ da empresa desejada, enquanto usuários externos selecionam o CNPJ atribuído às suas permissões;</li>
										<li>Busca da pessoa física: é realizada primeiramente no SGG e, caso não seja encontrada, é buscada na API da Receita Federal;</li>
										<li>Nome, sexo e data de nascimento: não são alteráveis pelo usuário que está cadastrando;</li>
										<li>Setor, cargo e data de admissão: são obrigatórios.</li>
									</ul>
									<p>
										Caso o cargo desejado não esteja na listagem, o usuário pode selecionar a opção
										<b> "Outro cargo - Descrever" </b> e realizar o cadastro com a descrição do cargo desejado.
									</p>
									<p>
										<b>Observação:</b> neste último caso, o funcionário só será cadastrado no sistema interno
										após a avaliação interna de uma atendente.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						{!externalUser
							? <>
								<Accordion
									expanded={aba === 'SCHEDULINGS'}
									onChange={handleChange('SCHEDULINGS')}
									sx={{backgroundColor: "#282828", width: "75%"}}
								>
									<AccordionSummary
										expandIcon={<ExpandMoreIcon />}
										aria-controls="SCHEDULINGS"
										id="SCHEDULINGS"
										sx={{display: "flex", justifyContent: "center"}}
									>
										<Typography variant='h6'>Como configurar agendas/fornecedores para cada empresa</Typography>
									</AccordionSummary>
									<AccordionDetails>
										<div className="card-docs">
											<p>
												No módulo de cadastro de funcionários, foi implementada a funcionalidade de auto-agendamento para os funcionários recém cadastrados.
												Nesta funcionalidade, a aplicação disponibilizará a data mais próxima disponível nas agendas relacionadas à empresa. <br /><br />
												Para determinar quais agendas são utilizadas para uma empresa específica, é necessário informar os dois tipos de fornecedores
												nas observações da empresa cadastrada no SGG. Exemplo:
											</p>
											<DocImage id='observations' src={observations} />
											<p>Exemplo de texto:</p>
											<TextField
												multiline
												sx={{width: "30vh"}}
												value={`CLÍNICOS:3,4\nCOMPLEMENTARES:24,25`}
											/>
											<p>Na linha com a palavra-chave "CLÍNICO" deve conter o ID do fornecedor ao qual devem ser realizados os exames <b><u>clínicos</u></b></p>
											<p>Na linha com a palavra-chave "COMPLEMENTARES" deve conter o ID do fornecedor ao qual devem ser realizados os exames <b><u>complementares</u></b></p> <br />
											<p>Onde obter o ID do fornecedor?</p>
											<DocImage id='observations' src={supliers} />
											<p>
												Para cada tipo, podem ser atribuídos mais de um ID de fornecedor, e conforme exemplificado acima, eles devem ser separados por vírgula.
												Eles serão validados na ordem de escrita, ou seja, ao utilizar os valores 3 e 4, o primeiro fornecedor a ser procurado com disponibilidade será o 3.
											</p>
										</div>
									</AccordionDetails>
								</Accordion>
								<Accordion
									expanded={aba === 'SCHEDULING-INTERVALS'}
									onChange={handleChange('SCHEDULING-INTERVALS')}
									sx={{backgroundColor: "#282828", width: "75%"}}
								>
									<AccordionSummary
										expandIcon={<ExpandMoreIcon />}
										aria-controls="SCHEDULING-INTERVALS"
										id="SCHEDULING-INTERVALS"
										sx={{display: "flex", justifyContent: "center"}}
									>
										<Typography variant='h6'>Como configurar o tempo de conclusão de exames de uma agenda</Typography>
									</AccordionSummary>
									<AccordionDetails>
										<div className="card-docs">
											<p>
												Durante o cadastro de um funcionário pela aplicação, o usuário pode realizar a confirmação dos exames admissionais de um funcionário.
												Dependendo do cargo do funcionário, pode ser necessária a realização de exames complementares antes do exame clínico (ASO).
											</p>
											<p>Por padrão, a aplicação sempre irá sugerir a data e horário do exame clínico para <b><u>1 hora após</u></b> a data de realização dos exames complementares.</p>
											<p>Exemplo: Se a aplicação sugerir o agendamento dos exames complementares em uma agenda, às 10:00, a aplicação só irá sugerir o agendamento do exame clínico às 11:00</p>
											<h2>E se o exame complementar leva mais que 1h para ficar concluído?</h2>
											<p>
												Podemos configurar este intervalo de conclusão de forma personalizada, para cada agenda. Neste caso, basta acessar
												as <Link target="_blank" rel="noopener" href="https://app.sgg.net.br/index.php?func=agenda_medica&metodo=cadastro_agenda_avulsa#">configurações da agenda no SGG</Link> e
												adicionar o período de conclusão no final do nome da agenda.
											</p>
											<p>Exemplo:</p>
											<DocImage src={schedule} />
											<p>
												Utilize "h" para <b>horas</b> e "d" para <b>dias</b>. O período especificado será o considerado para a sugestão de horário do exame clínico,
												após os complementares desta agenda. Se nenhum período for definido no nome da agenda, será usado o período padrão de 1h.
											</p>
											<p>Exemplo de uso com "3h": Se um agendamento de exame complementar for sugerido nesta agenda às 8:00, o exame clínico só será sugerido às 11:00 ou depois. O período definido se aplica a <b><u>todos</u></b> os exames realizados nesta agenda</p>
										</div>
									</AccordionDetails>
								</Accordion>
								</>
							: <></>
						}
						<Accordion
							expanded={aba === 'HOW-SCHEDULE'}
							onChange={handleChange('HOW-SCHEDULE')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="HOW-SCHEDULE"
								id="HOW-SCHEDULE"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Como realizar os agendamentos admissionais</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										Após realizadas as configurações mencionadas acima, será possível realizar o agendamento de
										exames admissionais dos funcionários cadastrados. Entenda abaixo os ícones e seus respectivos significados:
									</p>
									<div id='line-small'>
										<DocImage id='small' src={createdOnly} />
										<p>
											Indica que o funcionário foi cadastrado com sucesso. O fato de o ícone de agendamento não aparecer,
											significa que a empresa do funcionário não possui a agenda configurada conforme as seções acima.
										</p>
									</div>
									<div id='line-small'>
										<DocImage id='small' src={toSchedule} />
										<p>
											Indica que o funcionário foi cadastrado com sucesso e o seu agendamento está pendente - ainda não foi realizado.
										</p>
									</div>
									<div id='line-small'>
										<DocImage id='small' src={scheduledIcon} />
										<p>
											Indica que o funcionário foi cadastrado com sucesso e o seu agendamento foi realizado. Ao passar o mouse em cima do ícone é possível ver quando e qual usuário o fez.
										</p>
									</div>
									<br />
									<p>Quando um funcionário novo é cadastrado, o usuário pode agendá-lo através de uma tela semelhante a esta:</p>
									<DocImage src={scheduleCard} />
									<div id='line-small'>
										<p><b>Confirmar agendamentos:</b> confirma o agendamento dos exames, nas datas e horários sugeridos. Quando o funcionário possui exames complementares a serem realizados, é realizada a criação da solicitação de exames também.</p>
									</div>
									<div id='line-small'>
										<p><b>Escolher outro dia/horário:</b> este botão só aparece para os usuários externos, e encaminha o usuário para o WhatsApp da empresa - destinado aos clientes, quando desejarem agendar em outro dia, com um atendente.</p>
									</div>
									<div id='line-small'>
										<p>
											<b>Marcar como agendado internamente:</b> este botão só é visível para usuários internos. Ele deve ser usado
											para indicar que o cliente em questão foi agendado por fora da aplicação. Desta forma o botão de confirmação
											fica indisponível e o cliente não poderá mais agendar o funcionário pela aplicação.
										</p>
									</div>
									<div id='line-small'>
										<InfoOutlined/>
										<p>
											Este ícone também só é visível para usuários internos. Nele é possível ver toda a lógica que a aplicação
											considerou para apresentar os resultados obtidos para os agendamentos. Esta informação também é salva após
											a confirmação do agendamento, e é útil em casos onde possa ser necessário investigar o motivo de a aplicação apresentar uma data e horário.
										</p>
									</div>
								</div>
							</AccordionDetails>
						</Accordion>
					</>
				);
			case 'ENVIO_DOCUMENTOS':
				return (
					<>
						<Accordion
							expanded={aba === 'DELIVERY_OVERVIEW'}
							onChange={handleChange('DELIVERY_OVERVIEW')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="DELIVERY_OVERVIEW"
								id="DELIVERY_OVERVIEW"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Visão geral do módulo</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										O módulo de <b>Envio de documentos</b> envia documentos aos contatos das empresas clientes por
										WhatsApp e por e-mail, e guarda o histórico de tudo o que foi enviado.
									</p>
									<p>Os envios são organizados em três níveis:</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>Grupo:</b> a empresa matriz, que aparece na página inicial do módulo;</li>
										<li><b>Empresa:</b> a matriz e as filiais adicionadas ao grupo;</li>
										<li><b>Envio:</b> um ou mais arquivos, com uma mensagem, para um ou mais contatos de uma empresa.</li>
									</ul>
									<p>
										Os arquivos <b>não vão anexados</b>: o destinatário recebe a mensagem com um link para cada
										arquivo. Os contatos são os cadastrados na empresa no SGG.
									</p>
									<p>
										O envio em lote é feito salvando vários envios como pendentes e enviando todos de uma vez.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'DELIVERY_WHATSAPP'}
							onChange={handleChange('DELIVERY_WHATSAPP')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="DELIVERY_WHATSAPP"
								id="DELIVERY_WHATSAPP"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Conectar o WhatsApp</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										Os envios por WhatsApp saem de um número conectado à aplicação. O botão no topo da página
										inicial do módulo mostra a situação da conexão:
									</p>
									<DocImage src={waStatus} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>"WhatsApp conectado"</b> (verde): pronto para enviar. Clicar nele oferece a opção de desconectar;</li>
										<li><b>"Conectar WhatsApp"</b> (vermelho, balançando): nenhum número conectado. Clicar nele abre o QR code.</li>
									</ul>
									<p>
										Para conectar, escaneie o QR code pelo WhatsApp do celular que fará os envios, na opção de
										conectar um novo aparelho. Depois, feche a janela - o botão passa a mostrar "WhatsApp
										conectado". Se o QR code expirar antes da leitura, feche a janela e abra de novo.
									</p>
									<DocImage src={waQr} />
									<p>
										<b>Atenção:</b> a conexão é única para toda a aplicação. Desconectar o WhatsApp interrompe os
										envios de <b>todos os usuários</b>. Se o WhatsApp perder a sessão durante um envio, a aplicação
										desconecta o número e o botão volta a ficar vermelho - basta conectar de novo.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'DELIVERY_GROUPS'}
							onChange={handleChange('DELIVERY_GROUPS')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="DELIVERY_GROUPS"
								id="DELIVERY_GROUPS"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Listagem de empresas</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										A página de <Link target="_blank" rel="noopener" href="/envio-de-documentos">envio de
										documentos</Link> lista os grupos, um por empresa matriz:
									</p>
									<DocImage src={waList} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>Buscar empresa pelo nome: busca pelo nome da matriz;</li>
										<li>Filtrar por status: "Todos", "Envios pendentes" (grupos com algum envio pendente) ou "Enviados" (grupos sem envio pendente);</li>
										<li>Empresa: nome da matriz no SGG;</li>
										<li>CNPJ matriz: o botão ao lado copia o CNPJ;</li>
										<li>Último envio: data e hora do último documento enviado no grupo.</li>
									</ul>
									<p>
										As colunas Empresa e Último envio podem ser ordenadas clicando no título. Clicar no nome do
										grupo abre os envios dele.
									</p>
									<p>
										Grupos com envios pendentes ganham uma caixa de seleção. Ao marcar um ou mais grupos, aparece o
										botão <b>"Enviar Selecionados"</b>, que envia de uma vez <b>todos os envios pendentes</b> dos
										grupos marcados.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'DELIVERY_COMPANIES'}
							onChange={handleChange('DELIVERY_COMPANIES')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="DELIVERY_COMPANIES"
								id="DELIVERY_COMPANIES"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Cadastrar a matriz e as filiais</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										O botão <b>"Adicionar empresa"</b> da página inicial cria um grupo novo. Informe o CPF/CNPJ
										da <b>matriz</b> e clique em "Salvar":
									</p>
									<DocImage src={waCreate} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>CPF/CNPJ que não está no SGG: "Nenhuma empresa encontrada para o CNPJ";</li>
										<li>CNPJ de filial: "A empresa deste CNPJ não é a matriz!";</li>
										<li>Matriz que já tem grupo: "Grupo já cadastrado com este CNPJ/CPF".</li>
									</ul>
									<p>
										O grupo é criado vazio - <b>nem a própria matriz entra nele automaticamente</b>. Dentro do
										grupo, o botão "Adicionar empresa" inclui a matriz e as filiais que vão receber documentos, uma
										de cada vez:
									</p>
									<DocImage src={waFilial} />
									<p>
										Só são aceitas a própria matriz e as filiais dela no SGG - para as demais aparece "O CNPJ desta
										empresa não pertence à esta matriz!". Cada empresa aparece com o nome do SGG seguido
										de <b>"(matriz)"</b> ou do código da filial no SGG.
									</p>
									<p>
										<b>Observação:</b> grupos e empresas não podem ser removidos pela aplicação.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'DELIVERY_CONTACTS'}
							onChange={handleChange('DELIVERY_CONTACTS')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="DELIVERY_CONTACTS"
								id="DELIVERY_CONTACTS"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>De onde vêm os contatos</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>Os contatos não são digitados no envio - eles vêm do cadastro da empresa no SGG:</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>E-mail:</b> os e-mails do campo de e-mail da empresa;</li>
										<li>
											<b>WhatsApp:</b> os celulares da empresa marcados com <b>"(WhatsApp)"</b>. Celulares sem essa
											marcação não aparecem na lista.
										</li>
									</ul>
									<p>
										Para enviar a um contato novo, cadastre-o primeiro na empresa no SGG. Ele passa a aparecer
										depois que a aplicação sincroniza os dados do SGG.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'DELIVERY_NEW'}
							onChange={handleChange('DELIVERY_NEW')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="DELIVERY_NEW"
								id="DELIVERY_NEW"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Enviar um novo documento</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>Dentro do grupo, cada empresa tem o botão <b>"Enviar novo documento"</b>:</p>
									<DocImage src={waSend} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>Canal de envio:</b> WhatsApp, E-mail ou Ambos;</li>
										<li>
											<b>Contatos para o envio:</b> um ou mais contatos da empresa. Em "Ambos", celulares e e-mails
											aparecem juntos, e cada contato recebe pelo próprio canal - o celular por WhatsApp, o e-mail
											por e-mail;
										</li>
										<li><b>Tipo de documento:</b> o modelo de mensagem. Ao escolher, a mensagem é preenchida com o texto do modelo;</li>
										<li><b>Arquivos:</b> pelo botão "Adicionar arquivo" ou arrastando os arquivos sobre ele. Qualquer tipo de arquivo é aceito;</li>
										<li><b>Template de mensagem:</b> o texto que será enviado, que pode ser alterado só para este envio.</li>
									</ul>
									<p>
										No texto, <b>{"{{nome_empresa}}"}</b> é substituído pelo nome da empresa. Os links dos arquivos
										são acrescentados ao final da mensagem automaticamente.
									</p>
									<p>Para concluir, escolha uma das opções:</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>"Enviar":</b> envia na hora;</li>
										<li><b>"Salvar e enviar depois":</b> guarda o envio como pendente, para revisar ou enviar junto com outros.</li>
									</ul>
									<p>
										Se o mesmo tipo de documento já foi enviado hoje para os mesmos contatos, aparece um aviso
										amarelo de "Atenção" - o envio continua permitido.
									</p>
									<p>
										<b>Atenção:</b> cada mensagem de WhatsApp leva cerca de 5 segundos para sair. Em envios com
										muitos contatos, aguarde a conclusão sem clicar de novo.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'DELIVERY_TEMPLATES'}
							onChange={handleChange('DELIVERY_TEMPLATES')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="DELIVERY_TEMPLATES"
								id="DELIVERY_TEMPLATES"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Tipos de documento e templates</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										Os tipos de documento são modelos de mensagem compartilhados por todos os grupos e usuários. Na
										lista "Tipo de documento", o ícone de edição ao lado de cada tipo altera o modelo, e o botão
										"Criar novo template", no fim da lista, cria outro:
									</p>
									<DocImage src={waEditTemplate} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>
											<b>Título do template:</b> nome do tipo de documento, usado também como assunto dos e-mails.
											Não pode ser alterado depois;
										</li>
										<li><b>Mensagem do template:</b> texto padrão da mensagem, que pode conter {"{{nome_empresa}}"}.</li>
									</ul>
									<p>
										<b>Atenção:</b> alterar um template muda o texto para todos os usuários nos próximos envios.
										Criar um template com um título que já existe substitui a mensagem do existente. Templates não
										podem ser excluídos.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'DELIVERY_HISTORY'}
							onChange={handleChange('DELIVERY_HISTORY')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="DELIVERY_HISTORY"
								id="DELIVERY_HISTORY"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Acompanhar os envios de um grupo</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										Ao abrir um grupo, cada empresa aparece com a data do último documento enviado. Ao clicar,
										abre a tabela de envios dela, com os pendentes no topo:
									</p>
									<DocImage src={waSends} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>Tipo de documento;</li>
										<li>
											Enviado: <Check fontSize='small' color='success'/> enviado, <Clear fontSize='small' color='error'/> pendente,
											ou <ReportProblem fontSize='small' color='error'/> quando houve erro no envio por WhatsApp - o
											erro aparece ao passar o mouse;
										</li>
										<li>Canal: <WhatsApp fontSize='small' color='success'/>, <Email fontSize='small' color='info'/> ou os dois;</li>
										<li>Contato;</li>
										<li>Data de envio;</li>
										<li>Documento enviado: o ícone <PictureAsPdf fontSize='small' color='warning'/> abre cada arquivo, qualquer que seja o tipo;</li>
										<li>Mensagem enviada: o ícone <Chat fontSize='small' color='success'/> mostra o texto completo da mensagem;</li>
										<li>
											Arquivo visualizado pelo cliente: <Check fontSize='small' color='success'/> quando o link foi
											aberto, com a data ao passar o mouse, ou <Clear fontSize='small' color='error'/> quando ainda não foi;
										</li>
										<li>Ações: detalhadas em "Envios pendentes" e "Reenviar um documento".</li>
									</ul>
									<p>
										Os filtros do topo restringem a tabela por tipo de documento e por data de envio - este mês,
										últimos 30 dias, últimos 3 meses, este ano ou um período personalizado. "Limpar filtros" volta a
										mostrar tudo.
									</p>
									<p>
										<b>Observação:</b> o filtro de data considera a data de envio, por isso os envios pendentes
										ficam ocultos enquanto ele estiver ativo. Erros no envio por e-mail não são exibidos na tabela.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'DELIVERY_PENDING'}
							onChange={handleChange('DELIVERY_PENDING')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="DELIVERY_PENDING"
								id="DELIVERY_PENDING"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Envios pendentes</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										Envios salvos com "Salvar e enviar depois" ficam com <Clear fontSize='small' color='error'/> na
										coluna Enviado e têm três ações:
									</p>
									<DocImage src={waLate} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>
											<b>Selecionar para enviar:</b> marca o envio. Com algum envio marcado, aparece o botão
											"Enviar selecionados", que envia de uma vez todos os envios marcados no grupo, de qualquer empresa;
										</li>
										<li>
											<Edit fontSize='small' color='info'/> <b>Editar envio pendente:</b> permite trocar o canal, os
											contatos e a mensagem, e adicionar arquivos. O tipo de documento não muda, os arquivos já
											anexados não podem ser removidos e os links deles não podem ser apagados da mensagem;
										</li>
										<li>
											<DeleteOutline fontSize='small' color='error'/> <b>Excluir envio pendente:</b> apaga o envio e
											os arquivos anexados que não fazem parte de outro envio, sem possibilidade de recuperação.
										</li>
									</ul>
									<p>
										Antes de enviar, a aplicação pede confirmação em "Confirmar envio". Envios já realizados não
										podem ser editados nem excluídos.
									</p>
									<p>
										<b>Atenção:</b> clique uma única vez em "Enviar" na confirmação - um segundo clique envia tudo
										de novo.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'DELIVERY_RESEND'}
							onChange={handleChange('DELIVERY_RESEND')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="DELIVERY_RESEND"
								id="DELIVERY_RESEND"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Reenviar um documento</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										Envios já realizados têm o botão <Cached fontSize='small' color='secondary'/> "Reenviar". Ele
										abre o envio com o mesmo tipo e os mesmos arquivos, permitindo trocar o canal, os contatos e a
										mensagem - os links dos arquivos não podem ser apagados:
									</p>
									<DocImage src={waResend} />
									<p>
										O reenvio sai na hora e gera uma <b>nova linha</b> na tabela; o envio original continua
										registrado. Os dois compartilham os mesmos arquivos, por isso a coluna "Arquivo visualizado
										pelo cliente" fica igual nos dois.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'DELIVERY_RECIPIENT'}
							onChange={handleChange('DELIVERY_RECIPIENT')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="DELIVERY_RECIPIENT"
								id="DELIVERY_RECIPIENT"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>O que o destinatário recebe</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>WhatsApp:</b> uma mensagem de texto do número conectado, com o texto do envio e, ao final, um link para cada arquivo;</li>
										<li><b>E-mail:</b> o mesmo texto, com o tipo de documento como assunto e cópia oculta para o e-mail de contato da Inovação.</li>
									</ul>
									<p>
										O link abre o arquivo sem pedir login - PDFs e imagens abrem no navegador, os demais tipos são
										baixados. Os links não expiram.
									</p>
									<p>
										A coluna "Arquivo visualizado pelo cliente" é marcada quando o link do arquivo é aberto, e a data
										mostrada é a do acesso mais recente. Não é a confirmação de leitura do WhatsApp, que não é
										acompanhada pela aplicação. Respostas do destinatário chegam apenas no celular do número conectado.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
					</>
				);
			case 'GESTAO_DENUNCIAS':
				return (
					<>
						{permissions.includes('MANAGEMENT_COMPLAINTS')
							? <Accordion
								expanded={aba === 'MANAGEMENT_COMPLAINTS'}
								onChange={handleChange('MANAGEMENT_COMPLAINTS')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="MANAGEMENT_COMPLAINTS"
									id="MANAGEMENT_COMPLAINTS"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Como configurar um canal de denúncias</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Ao acessar o módulo de Gestão de denúncias, é possível visualizar os canais de denúncias configurados. Exemplo:
										</p>
										<DocImage id='observations' src={canais} />
										<p>Para adicionar um canal de denúncia para uma empresa, clique em "+ Adicionar empresa" e digite o CNPJ/CPF da empresa matriz. Exemplo:</p>
										<DocImage id='observations' src={criarCanal} />
										<p>
											Você pode ativar ou desativar um canal de denúncias para uma empresa utilizando o seletor "Canal ativo".
											Ao desativar um canal, não será possível receber novas denúncias para este canal
										</p>
										<p>
											Ao clicar em uma empresa, serão exibidas as filiais cadastradas para esta empresa,
											e para cada uma é exibido o ícone de QR code, para disponibilizar o QR code e link
											para o canal de denúncias da empresa. Exemplo:
										</p>
										<DocImage id='observations' src={canalQR} />
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
						{permissions.includes('COMPLAINTS')
							? <Accordion
								expanded={aba === 'COMPLAINT_FORM'}
								onChange={handleChange('COMPLAINT_FORM')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="COMPLAINT_FORM"
									id="COMPLAINT_FORM"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Formulário de denúncia para colaboradores</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Ao acessar o link obtido no painel, o colaborador da empresa pode realizar o cadastro de uma denúncia anônima,
											assim como realizar o acompanhamento de uma existente com um protocolo. Exemplo:
										</p>
										<Grid spacing={2}>
											<DocImage style={{height: '700px'}} id='form' src={denunciaForm} />
											<DocImage style={{height: '700px'}} id='form' src={denunciaAcompanha} />
										</Grid>
										<p>
											O denunciante pode optar pela informação do cargo ou não, mas a informação do setor é obrigatória
											para o registro. Ao registrar a denúncia, o colaborador recebe seu protocolo para acompanhamento.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
						{permissions.includes('COMPLAINTS')
							? <Accordion
								expanded={aba === 'COMPLAINTS'}
								onChange={handleChange('COMPLAINTS')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="COMPLAINTS"
									id="COMPLAINTS"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Painel de denúncias</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Ao acessar o Painel de denúncias, é possível visualizar todas as denúncias registradas no canal.
											Neste painel é possível buscar uma denúncia por protocolo ou filtrar por características. Exemplo:
										</p>
										<DocImage id='observations' src={denuncias} />
										<p>Neste painel também é possível exportar as denúncias exibidas, desde que o usuário possua permissão para a exportação</p>
										<p>
											Ao clicar em uma denúncia, é possível visualizar as informações detalhadas dela.
											Só serão listadas denúncias para um usuário caso ele seja um responsável que recebeu
											atribuição da denúncia para as devidas ações.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
						{permissions.includes('COMPLAINTS')
							? <Accordion
								expanded={aba === 'COMPLAINTS_DETAILS'}
								onChange={handleChange('COMPLAINTS_DETAILS')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="COMPLAINTS_DETAILS"
									id="COMPLAINTS_DETAILS"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Informações detalhadas da denúncia</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Ao clicar em uma denúncia, o usuário pode visualizar as informações detalhadas dela. Exemplo:
										</p>
										<DocImage id='observations' src={denuncia} />
										<p>No primeiro card, é possível visualizar as informações registradas pelo denunciante, assim como os arquivos anexados pelo mesmo.</p>
										<p>
											O card do meio, de classificação final, só é editável por usuários que possuem permissão de classificação.
											Estes usuários podem classificar uma denúncia e atribuir outros usuários como responsáveis para ações e medidas a
											serem tomadas em relação à denúncia.
										</p>
										<p>No card superior direito, é possível visualizar o histórico da denúncia. Nele é possível ver as ações e datas de cada atividade.</p>
										<p>
											No card inferior é apresentado o plano de ações da denúncia, definido pelo usuário gestor com permissão de classificação.
											Nele são listadas todas as ações criadas, bem como seus respectivos responsáveis. Cada usuário atribuído recebe um
											e-mail assim que recebe a atribuição de uma denúncia. Quando a última ação é concluída pelo usuário responsável,
											a denúncia é finalizada automaticamente.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
					</>
				);
			case 'CADASTRO_AVULSO':
				return (
					<Accordion
						expanded={aba === 'CADASTRO_AVULSO'}
						onChange={handleChange('CADASTRO_AVULSO')}
						sx={{backgroundColor: "#282828", width: "75%"}}
					>
						<AccordionSummary
							expandIcon={<ExpandMoreIcon />}
							aria-controls="CADASTRO_AVULSO"
							id="CADASTRO_AVULSO"
							sx={{display: "flex", justifyContent: "center"}}
						>
							<Typography variant='h6'>Formulário de cadastro de colaboradores</Typography>
						</AccordionSummary>
						<AccordionDetails>
							<div className="card-docs">
								<p>
									O
									<Link target="_blank" rel="noopener" href="/audiometria/novo-cadastro"> formulário para cadastro de funcionários </Link>
									permite ao usuário cadastrar os seus dados para a realização de audiometria.
								</p>
								<Grid container spacing={2} className='audiometria-gallery'>
									<Grid item xs={12} sm={6}>
										<DocImage src={audiometria} />
									</Grid>
									<Grid item xs={12} sm={6}>
										<DocImage src={audiometria2} />
									</Grid>
								</Grid>
								<p>
									Ao realizar o cadastro, as informações são enviadas para o SGG. Se a empresa não possui cadastro no SGG,
									ela será cadastrada, e o funcionário também. O setor e cargo utilizados para o funcionário serão "Geral". Exemplo:
								</p>
								<DocImage id='observations' src={sgg} />
							</div>
						</AccordionDetails>
					</Accordion>
				);
			case 'AUDITORIA_ADMISSOES':
				return (
					<>
						<Accordion
							expanded={aba === 'AUDITORIA_ADMISSOES'}
							onChange={handleChange('AUDITORIA_ADMISSOES')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="AUDITORIA_ADMISSOES"
								id="AUDITORIA_ADMISSOES"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Criação e listagem de empresa</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										O painel inicial do módulo Auditoria de admissões lista as empresas cadastradas para a funcionalidade.
										Somente usuários com a devida permissão podem adicionar novas empresas. Exemplo do módulo:
									</p>
									<DocImage src={audit} />
									<p>
										Para usuários internos, são listadas todas as empresas cadastradas,
										e para os demais, a listagem é feita conforme a configuração do usuário.
										Se a empresa ou matriz do usuário possuir registros, ela será listada.
									</p>
									<p>
										O botão de "Configurações & LGPD" também só é acessível para usuários
										com permissão de acesso ao painel LGPD, e o botão "Visualizar admissões"
										encaminha o usuário para a listagem de admissões existentes.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'ADMISSION_FORM'}
							onChange={handleChange('ADMISSION_FORM')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="ADMISSION_FORM"
								id="ADMISSION_FORM"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Formulário de admissão</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										Ao criar um link de admissão pelo módulo de Auditoria, será disponibilizada uma URL
										de acesso para ser enviada ao candidato. Através deste link, o candidato pode realizar
										o envio de documentos e preenchimento de informações de admissão. Exemplo do formulário:
									</p>
									<Grid container spacing={2} className='audiometria-gallery'>
										<Grid item xs={12} sm={6}>
											<DocImage style={{height: '700px'}} src={form1} />
										</Grid>
										<Grid item xs={12} sm={6}>
											<DocImage style={{height: '700px'}} src={form2} />
										</Grid>
										<Grid item xs={12} sm={6}>
											<DocImage style={{height: '700px'}} src={form3} />
										</Grid>
										<Grid item xs={12} sm={6}>
											<DocImage style={{height: '700px'}} src={form4} />
										</Grid>
									</Grid>
								</div>
							</AccordionDetails>
						</Accordion>
						{permissions.includes('LGPD_POLICY_CONFIG')
							? <Accordion
								expanded={aba === 'LGPD_POLICY_CONFIG'}
								onChange={handleChange('LGPD_POLICY_CONFIG')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="LGPD_POLICY_CONFIG"
									id="LGPD_POLICY_CONFIG"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Painel LGPD</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Sempre que uma empresa é adicionada no módulo inicial de Auditoria de admissões, um
											registro de Configurações & LGPD é criado automaticamente com configurações predefinidas. Exemplo do módulo:
										</p>
										<DocImage src={lgpd} />
										<p>
											Este painel permite aos gestores configurarem a exclusão automática de
											documentos armazenados de admissões cadastradas pelo formulário.
											Caso o gestor não deseje que os documentos sejam apagados do sistema,
											deve ser desativada a opção "Ativar exclusão automática de documentos".
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
						<Accordion
							expanded={aba === 'ADMISSOES'}
							onChange={handleChange('ADMISSOES')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="ADMISSOES"
								id="ADMISSOES"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Listagem de admissões</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										Ao acessar o painel de admissões, serão listadas todas as admissões criadas pela aplicação.
										Nesta tela é possível visualizar informações úteis como nome do candidato, data de expiração
										do link, status, entre outros. Para acessar e visualizar os dados de uma admissão, basta
										clicar no item da listagem. Exemplo do módulo:
									</p>
									<DocImage id='observations' src={admissoes} />
									<p>
										Quando uma admissão expira pela data definida na criação do link, a mesma fica indisponível.
										Quando o candidato completa todas as etapas do formulário de admissão, o link também é fechado no momento da conclusão.
									</p>
									<p>Para admissões com o link fechado, é possível reabrir usando o botão de reabertura.
										Essa reabertura só é permitida para links de admissão que não expiraram pela data.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'LOGS'}
							onChange={handleChange('LOGS')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="LOGS"
								id="LOGS"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Visualização de dados e documentos do candidato</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										Ao acessar uma admissão, é possível visualizar os dados e documentos enviados pelo candidato.
										Neste painel são disponibilizadas as etapas de informações preenchidas, além dos
										"logs" da atividade da admissão. Exemplo do módulo:
									</p>
									<DocImage id='observations' src={admission} />
									<p>
										Na aba de logs, é possível visualizar toda e qualquer atividade rastreada e realizada com os dados do candidato:
									</p>
									<DocImage id='observations' src={admission1} />
									<p>A visualização de documentos do candidato só é acessível para usuários com permissão.</p>
								</div>
							</AccordionDetails>
						</Accordion>
						{permissions.includes('STATUS_ADMISSION')
							? <Accordion
								expanded={aba === 'STATUS'}
								onChange={handleChange('STATUS')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="STATUS"
									id="STATUS"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Alteração de status da admissão</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Ao acessar uma admissão, é possível realizar a alteração de status do registro e notificar o candidato por e-mail. Exemplo do módulo:
										</p>
										<DocImage id='observations' src={status} />
										<p><strong>Observação:</strong> Para notificar o candidato é necessário que ele tenha informado o campo de e-mail</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
					</>
				);
			case 'INSPECAO_EPIS':
				return (
					<>
						<Accordion
							expanded={aba === 'EPI_VISAO_GERAL'}
							onChange={handleChange('EPI_VISAO_GERAL')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="EPI_VISAO_GERAL"
								id="EPI_VISAO_GERAL"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Visão geral do módulo</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										O módulo de <b>Inspeção de EPIs</b> organiza a evidência de conformidade com a
										NR-06: quais Equipamentos de Proteção Individual cada colaborador precisa usar,
										se ele foi inspecionado usando-os corretamente, e o que é feito quando algo é
										encontrado fora de conformidade.
									</p>
									<p>O fluxo segue sempre a mesma sequência:</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>Um inspetor seleciona um colaborador e inicia uma inspeção;</li>
										<li>Classifica cada EPI recomendado para a função como OK, NÃO OK ou NÃO APLICÁVEL;</li>
										<li>O colaborador toma ciência do resultado e das orientações recebidas;</li>
										<li>As duas partes assinam, e a inspeção é concluída;</li>
										<li>Todo item marcado como NÃO OK vira automaticamente uma ação corretiva, que é acompanhada até a resolução.</li>
									</ul>
									<p>
										<b>Atenção:</b> uma inspeção concluída é evidência legal de conformidade com a
										NR-06 e <b><u>não pode mais ser editada</u></b> depois de finalizada - nem os
										itens do checklist, nem as observações, nem as assinaturas. Qualquer correção
										necessária é feita através de uma nova inspeção.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						{permissions.includes('MANAGE_EPI_COMPANIES')
							? <Accordion
								expanded={aba === 'EPI_CONFIG'}
								onChange={handleChange('EPI_CONFIG')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="EPI_CONFIG"
									id="EPI_CONFIG"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Configuração por empresa</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Antes de uma empresa aparecer no módulo, ela precisa ser adicionada e habilitada
											na tela de <b>Configurações</b>, acessível pelo botão "Configurações" do painel.
										</p>
										<DocImage src={epiConfiguration} />
										<p>
											Para adicionar uma empresa nova, informe o CPF/CNPJ da empresa matriz e
											clique em "Adicionar empresa". Ela entra desabilitada, e só passa a
											aparecer no painel, na seleção de colaborador e nos demais relatórios depois
											de habilitada pelo seletor "Habilitada".
										</p>
										<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
											<li><b>Habilitada:</b> controla se a empresa aparece nas telas do módulo;</li>
											<li>
												<b>Periodicidade (dias):</b> de quantos em quantos dias um colaborador
												precisa ser inspecionado novamente. É esse número que define quando a
												situação dele passa de "Inspecionado" para "Vencendo" e depois para
												"Não inspecionado";
											</li>
											<li>
												<b>Logo:</b> imagem PNG ou JPG da empresa, uma por empresa, que substitui a
												logo padrão no cabeçalho de todos os relatórios em PDF do módulo (dossiê da
												inspeção, inspeções realizadas e Gestão da Conformidade). Use "Enviar logo" para
												cadastrar, "Trocar logo" para substituir e o botão de lixeira para remover;
												sem logo cadastrada, os relatórios usam a logo padrão. A imagem é reduzida
												automaticamente no envio e, no PDF, ocupa no máximo 4 cm de largura por 2 cm
												de altura, mantendo a proporção. A logo é gravada na hora, sem precisar do
												botão "Salvar";
											</li>
										</ul>
										<p>
											<b>Observação:</b> a meta do Índice de Conformidade NR-06 exibida nos
											painéis e no dashboard é fixa para todo o sistema - não é configurável por
											empresa nesta tela.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
						<Accordion
							expanded={aba === 'EPI_PAINEL'}
							onChange={handleChange('EPI_PAINEL')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="EPI_PAINEL"
								id="EPI_PAINEL"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Painel de Conformidade NR-06</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										É a tela inicial do módulo. Ao selecionar uma empresa habilitada, são exibidos
										seis indicadores consolidados:
									</p>
									<DocImage src={painelNr06} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>Índice de Conformidade NR-06:</b> percentual de itens OK entre tudo o que foi classificado como OK ou NÃO OK, com a meta ao lado;</li>
										<li><b>Colaboradores monitorados:</b> quantos colaboradores possuem ao menos um EPI recomendado na avaliação de riscos vigente do cargo;</li>
										<li><b>Não conformidades abertas:</b> ações corretivas ainda não concluídas;</li>
										<li><b>Substituições pendentes:</b> não conformidades cujo motivo exige a troca do EPI;</li>
										<li><b>Colaboradores não inspecionados no mês:</b> quem está sem inspeção concluída dentro do período (situação "Sem inspeção no período");</li>
										<li><b>Orientações / Treinamentos pendentes.</b></li>
									</ul>
									<p>
										<b>Observação:</b> só são monitorados colaboradores com EPI recomendado na
										avaliação de riscos (PGR) vigente do cargo e setor. Quem não possui nenhuma
										recomendação aparece como "Não aplicável" e não entra na contagem do índice.
									</p>
									<p>
										Abaixo dos indicadores ficam as <b>ações rápidas</b>, que levam diretamente
										para nova inspeção, acompanhamento, plano de ação e dashboard, conforme a
										permissão de quem está navegando.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						{permissions.includes('CREATE_EPI_INSPECTION')
							? <Accordion
								expanded={aba === 'EPI_SELECIONAR'}
								onChange={handleChange('EPI_SELECIONAR')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="EPI_SELECIONAR"
									id="EPI_SELECIONAR"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Selecionar colaborador</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Ao clicar em "Nova inspeção", é exibida a lista de colaboradores da empresa
											selecionada. Só aparecem na lista os colaboradores ativos da empresa - a
											lista não se limita a quem já tem EPI recomendado, mas quem não tem
											aparece marcado como "Não aplicável" e sem o botão de inspecionar.
										</p>
										<DocImage src={epiColaborador} />
										<DocImage src={itemInspecionado} />
										<p>É possível filtrar por setor, cargo, situação e buscar por nome ou matrícula.</p>
										<p>Cada colaborador aparece com uma cor de acordo com a situação dele:</p>
										<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
											<li><b>Inspecionado</b> (verde) - dentro do período de validade da última inspeção;</li>
											<li><b>Vencendo</b> (laranja) - faltam 20% ou menos do prazo da periodicidade para a inspeção vencer;</li>
											<li><b>Não inspecionado</b> (vermelho) - nunca foi inspecionado, ou a última inspeção já venceu;</li>
											<li><b>Não aplicável</b> (cinza) - função sem nenhum EPI recomendado na avaliação de riscos vigente; não é possível iniciar inspeção para ele.</li>
										</ul>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
						{permissions.includes('CREATE_EPI_INSPECTION')
							? <Accordion
								expanded={aba === 'EPI_CHECKLIST'}
								onChange={handleChange('EPI_CHECKLIST')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="EPI_CHECKLIST"
									id="EPI_CHECKLIST"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Checklist de EPIs</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Ao iniciar a inspeção, é aberta a primeira etapa do assistente, com a tabela
											de EPIs recomendados para a função do colaborador. Cada linha mostra o
											número do CA e a data da última entrega registrada no SGG, quando existirem.
										</p>
										<DocImage src={itemInspecionado} />
										<p>Cada EPI é classificado em uma das três opções:</p>
										<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
											<li><b>OK:</b> o colaborador possui e utiliza o EPI corretamente;</li>
											<li><b>NÃO OK:</b> foi identificada alguma irregularidade;</li>
											<li><b>NÃO APLICÁVEL:</b> o EPI não se aplica à atividade realizada no momento.</li>
										</ul>
										<p>
											Ao marcar um item como <b>NÃO OK</b>, a linha se expande e passa a exigir o
											<b> motivo da não conformidade</b>: uso incorreto, colaborador não estava
											utilizando o EPI, dano, extravio, inadequação, necessidade de troca ou
											<b> outro motivo</b>. A ação imediata realizada e uma observação
											específica são opcionais, assim como a foto de evidência, anexada pelo
											botão "Anexar foto".
										</p>
										<p>
											Quando nenhuma opção da lista descreve a situação, escolha <b>"Outro motivo
											(descrever)"</b> no motivo ou <b>"Outra ação (descrever)"</b> na ação
											imediata: um campo de texto aparece logo abaixo para digitar livremente. O
											texto digitado é o que aparece depois no resumo, no dossiê e na tela de
											não conformidades. Ao escolher uma dessas opções, a descrição passa a ser
											obrigatória.
										</p>
										<p>
											É possível interromper o preenchimento a qualquer momento com "Salvar
											rascunho" e retomar depois - a inspeção fica com status de rascunho até a
											conclusão. Para seguir para a próxima etapa é preciso classificar todos os
											EPIs, informar o motivo de todo item NÃO OK e descrever os que usam "Outro".
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
						{permissions.includes('CREATE_EPI_INSPECTION')
							? <Accordion
								expanded={aba === 'EPI_RESUMO'}
								onChange={handleChange('EPI_RESUMO')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="EPI_RESUMO"
									id="EPI_RESUMO"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Resumo e ciência do trabalhador</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											A segunda etapa mostra o resultado calculado da inspeção: <b>CONFORME</b>,
											se todos os itens classificados são OK, ou <b>NÃO CONFORME</b>, se ao
											menos um item foi marcado como NÃO OK.
										</p>
										<DocImage src={resumoCiencia} />
										<p>
											Abaixo do resultado ficam cinco declarações de ciência - sobre as condições
											registradas, orientação de uso, guarda e conservação, comunicação de
											dano/extravio, e ciência das não conformidades. O colaborador marca as que
											confirma. <b>Marcar não é obrigatório</b>: é possível seguir adiante com
											algumas ou nenhuma marcada.
										</p>
										<p>
											Apenas as declarações marcadas são gravadas como ciência do trabalhador.
											Se nenhuma for marcada, a inspeção segue sem ciência registrada - a tela de
											assinaturas mostra "Ciência registrada: Não" e o dossiê mostra a ciência
											como "Não registrada". Nada é registrado como aceito sem ter sido marcado.
										</p>
										<p>
											<b>Observação:</b> o texto das declarações é gravado junto com uma versão.
											Se o texto mudar no futuro, as inspeções já assinadas continuam mostrando
											exatamente o texto que foi aceito na época, não o texto atual.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
						{permissions.includes('CREATE_EPI_INSPECTION')
							? <Accordion
								expanded={aba === 'EPI_EXAMES'}
								onChange={handleChange('EPI_EXAMES')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="EPI_EXAMES"
									id="EPI_EXAMES"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Pendências de exames</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											A terceira etapa mostra as pendências de exames ocupacionais do PCMSO do
											colaborador. <b>Esses dados vêm do espelho local do SGG</b>, não são
											consultados nem calculados pela aplicação de Inspeção de EPIs.
										</p>
										<DocImage src={pendenciasExames} />
										<p>
											Se não houver nenhuma pendência, a etapa é apenas informativa e segue
											direto para as assinaturas. Havendo pendência, o colaborador precisa marcar
											a ciência de que foi informado sobre elas para poder continuar - essa
											confirmação também fica registrada no dossiê da inspeção.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
						{permissions.includes('CREATE_EPI_INSPECTION')
							? <Accordion
								expanded={aba === 'EPI_ASSINATURAS'}
								onChange={handleChange('EPI_ASSINATURAS')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="EPI_ASSINATURAS"
									id="EPI_ASSINATURAS"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Assinaturas e finalização</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											A última etapa coleta duas assinaturas, sempre <b>nesta ordem</b>: primeiro
											o <b>colaborador</b>, depois o <b>responsável pela inspeção</b>. A
											assinatura do responsável só fica disponível depois que o colaborador assina.
										</p>
										<DocImage src={assinaturas} />
										<p>
											<b>Atenção:</b> depois que o colaborador assina, o checklist, as evidências
											e as observações da inspeção não podem mais ser alterados - o conteúdo não
											pode mudar depois que alguém já deu ciência dele.
										</p>
										<p>
											Ao confirmar a assinatura do responsável, a inspeção é <b>concluída</b>:
											recebe o número sequencial, o resultado final é gravado, e cada item
											marcado como NÃO OK gera automaticamente uma ação corretiva, já atribuída
											ao próprio inspetor e com prazo de <b>7 dias</b> - não é preciso criar nada
											manualmente. A partir daqui a tela oferece visualizar a inspeção, imprimir
											o relatório ou iniciar uma nova.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
						{permissions.includes('CANCEL_EPI_INSPECTION')
							? <Accordion
								expanded={aba === 'EPI_CANCELAR'}
								onChange={handleChange('EPI_CANCELAR')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="EPI_CANCELAR"
									id="EPI_CANCELAR"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Cancelar uma inspeção</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Enquanto a inspeção ainda está em rascunho, o botão "Cancelar inspeção" fica
											disponível na etapa de checklist. Ele pede um motivo obrigatório e, ao
											confirmar, muda o status da inspeção para Cancelada - os itens já
											preenchidos continuam gravados, mas a inspeção deixa de contar para
											qualquer indicador.
										</p>
										<p>
											Uma inspeção já cancelada não pode ser cancelada novamente. O motivo do
											cancelamento é exigido e fica gravado, mas <b>não é exibido em nenhuma
											tela</b> hoje - nem no dossiê, nem em outro painel. O histórico do dossiê
											mostra apenas que a inspeção foi cancelada, com data e autor, sem o motivo.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
						{permissions.includes('EPI_COMPLIANCE')
							? <Accordion
								expanded={aba === 'EPI_GESTAO_CONFORMIDADE'}
								onChange={handleChange('EPI_GESTAO_CONFORMIDADE')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="EPI_GESTAO_CONFORMIDADE"
									id="EPI_GESTAO_CONFORMIDADE"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Gestão da Conformidade NR-06</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Esta tela detalha, colaborador a colaborador, a situação de conformidade da
											empresa selecionada, com filtro por setor, cargo, situação, colaborador e
											por período (datas "De" e "Até").
										</p>
										<DocImage src={gestao} />
										<p>Os indicadores no topo mostram colaboradores monitorados, conformes, não conformes, sem inspeção no período e o Índice de Conformidade NR-06 frente à meta.</p>
										<p>
											A tabela lista, para cada colaborador, o índice individual, a última
											inspeção, quantas não conformidades e ações em andamento ele tem, os
											exames pendentes e a situação (Conforme, Não conforme ou Sem inspeção no
											período). O link de cada linha abre a última inspeção do colaborador.
										</p>
										<p>
											O período informado nos filtros "De" e "Até" delimita a janela considerada
											para calcular quem está "Sem inspeção no período" e os demais números.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
						{permissions.includes('EPI_INSPECTION')
							? <Accordion
								expanded={aba === 'EPI_ACOMPANHAMENTO'}
								onChange={handleChange('EPI_ACOMPANHAMENTO')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="EPI_ACOMPANHAMENTO"
									id="EPI_ACOMPANHAMENTO"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Acompanhamento e dossiê</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											A tela de "Inspeções realizadas" lista todas as inspeções da empresa
											selecionada, com o número sequencial, a data, o colaborador, quantos itens
											foram OK/NÃO OK/não aplicáveis e o resultado. É possível filtrar por
											colaborador, matrícula, número, resultado e período.
										</p>
										<DocImage src={inspecoes} />
										<p>
											A contagem de resultados mostra o período consultado, por exemplo
											"Resultados encontrados entre 01/09/2026 e 30/09/2026: 3". Com só a data
											"De" preenchida, a consulta traz as inspeções <b>a partir</b> dela; com só a
											data "Até", traz <b>todas</b> as inspeções até ela. Sem nenhuma das duas, a
											consulta cobre do primeiro dia do mês atual até hoje, e a contagem mostra
											esse período.
										</p>
										<p>
											Cada coluna da tabela pode ser ordenada clicando no título: o primeiro clique
											ordena em ordem crescente, o seguinte inverte. O ícone ao lado do título mostra
											a coluna e o sentido da ordenação atual; por padrão, as inspeções mais
											recentes aparecem primeiro. O relatório exportado sai na mesma ordem da tela
											e informa o período filtrado e a ordenação usada.
										</p>
										<p>
											Ao abrir uma inspeção, é exibido o <b>dossiê</b> completo, organizado em
											seis abas: <b>Dados gerais</b>, <b>Itens inspecionados</b>,
											<b> Não conformidades</b>, <b>Ações corretivas</b>, <b>Fotos e
											evidências</b> e <b>Histórico</b>.
										</p>
										<DocImage src={inspecao} />
										<p>
											O número sequencial atribuído na conclusão da inspeção aparece tanto no
											dossiê quanto nos relatórios impressos, e serve para identificar a
											inspeção de forma única perante o SESMT ou uma fiscalização.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
						{permissions.includes('EPI_NONCONFORMITY')
							? <Accordion
								expanded={aba === 'EPI_NAO_CONFORMIDADES'}
								onChange={handleChange('EPI_NAO_CONFORMIDADES')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="EPI_NAO_CONFORMIDADES"
									id="EPI_NAO_CONFORMIDADES"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Não conformidades e plano de ação</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											Toda vez que uma inspeção é concluída com algum item NÃO OK, uma ação
											corretiva é criada automaticamente nesta tela, já com o inspetor como
											responsável inicial e prazo de 7 dias. Uma ação passa pelos
											status <b>Aberta</b>, <b>Em andamento</b> e <b>Concluída</b>.
										</p>
										<DocImage src={naoConformidade} />
										<p>
											<b>Vencida</b> não é um status próprio - é calculado a partir do prazo: uma
											ação ainda aberta ou em andamento cujo prazo já passou aparece como Vencida
											sozinha, sem que ninguém precise marcar isso manualmente.
										</p>
										<p>
											Os motivos <b>dano, extravio, inadequação e necessidade de troca</b> geram
											uma <b>substituição pendente</b>. Uso incorreto, colaborador não estava
											utilizando o EPI e outro motivo não geram. Essa marcação vem do
											motivo escolhido no checklist, não é uma escolha separada de quem trata a ação.
										</p>
										<p>
											O filtro <b>Situação</b> e as abas são o mesmo filtro: escolher uma situação
											no filtro seleciona a aba correspondente, e clicar numa aba atualiza o filtro.
											"Limpar filtros" volta para todas as situações.
										</p>
										<p>
											O filtro de período (<b>De</b> e <b>Até</b>) considera a data da inspeção
											que gerou a não conformidade e vale para a tela inteira: indicadores,
											contagens das abas, tabela e relatório exportado. Com só a data "De", entram
											as não conformidades a partir dela; com só a data "Até", todas até ela; sem
											nenhuma das duas, aparecem todas as não conformidades da empresa.
										</p>
										<p>
											Ao selecionar uma ação é possível ver o histórico de todas as alterações
											feitas nela, com data, autor e o que mudou.
										</p>
										<p>
											O botão <b>"Exportar relatório"</b>, ao lado das abas, gera um PDF com as
											ações que estão na tela: respeita a aba escolhida (Todas, Abertas, Em
											andamento, Vencidas ou Concluídas) e todos os filtros aplicados. O relatório
											traz os filtros usados, os totais por situação e, para cada ação, a inspeção,
											o colaborador e o setor, o EPI, o motivo, a descrição do problema, a ação
											imediata, a ação corretiva, o responsável, o prazo e a situação. O botão só
											aparece para quem tem a permissão de exportar relatórios e fica desabilitado
											quando nenhuma ação está listada.
										</p>
										<p>
											<b>Atenção à permissão:</b> editar o status, o responsável, o prazo e a
											ação corretiva definida exige a permissão adicional <b>"Resolver não
											conformidades"</b>. Sem ela, o painel de detalhes da ação é somente
											leitura. E mesmo com a permissão, <b>uma ação já concluída não pode ser
											reaberta</b> nem alterada novamente.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
						{permissions.includes('EPI_DASHBOARD')
							? <Accordion
								expanded={aba === 'EPI_DASHBOARD'}
								onChange={handleChange('EPI_DASHBOARD')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="EPI_DASHBOARD"
									id="EPI_DASHBOARD"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Dashboard NR-06</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>
											O dashboard consolida a conformidade da empresa selecionada, com filtro por
											setor e por período (data de/até).
										</p>
										<DocImage src={dashboard} />
										<p>
											Os indicadores do topo mostram inspeções realizadas, conformidade geral
											frente à meta, não conformidades (com a parcela ainda aberta), colaboradores
											envolvidos e pendências de exames (com as vencidas em destaque).
										</p>
										<p>Logo abaixo, três roscas (donuts) resumem:</p>
										<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
											<li>Conformidade por setor;</li>
											<li>Status das inspeções (situação de cada colaborador monitorado);</li>
											<li>Não conformidades por status (abertas, em andamento, vencidas, concluídas).</li>
										</ul>
										<p>
											<b>Atenção ao reconciliar números:</b> nesta rosca, "Abertas" mostra só as
											ações dentro do prazo - toda ação ainda não concluída cujo prazo já
											passou cai na fatia "Vencidas", mesmo que o status dela ainda
											seja Aberta ou Em andamento. Por isso a soma de "Abertas" com "Vencidas"
											aqui é que corresponde ao card "Não conformidades abertas" do Painel, e
											não a fatia "Abertas" sozinha.
										</p>
										<p>
											Nos dois gráficos finais, a <b>evolução da conformidade</b> mostra o
											índice ao longo do período frente à linha de meta, e o gráfico de barras
											mostra as <b>pendências de exames por status</b>.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
						{permissions.includes('EXPORT_EPI_REPORT')
							? <Accordion
								expanded={aba === 'EPI_RELATORIOS'}
								onChange={handleChange('EPI_RELATORIOS')}
								sx={{backgroundColor: "#282828", width: "75%"}}
							>
								<AccordionSummary
									expandIcon={<ExpandMoreIcon />}
									aria-controls="EPI_RELATORIOS"
									id="EPI_RELATORIOS"
									sx={{display: "flex", justifyContent: "center"}}
								>
									<Typography variant='h6'>Relatórios em PDF</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<div className="card-docs">
										<p>O módulo gera quatro relatórios em PDF, cada um a partir da tela a que se refere:</p>
										<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
											<li>
												<b>Relatório de conformidade</b> - botão "Exportar relatório" na tela de
												Gestão da Conformidade NR-06, com os indicadores e a tabela filtrada no momento;
											</li>
											<li>
												<b>Relatório de inspeções</b> - botão "Exportar relatório" na tela de
												Inspeções realizadas, com a listagem filtrada no momento;
											</li>
											<li>
												<b>Relatório de não conformidades</b> - botão "Exportar relatório", ao lado
												das abas na tela de Não conformidades e plano de ação, com as ações da aba
												e dos filtros selecionados no momento;
											</li>
											<li>
												<b>Dossiê da inspeção</b> - botão "Imprimir relatório", disponível tanto
												ao final do assistente de inspeção quanto na tela de dossiê, com todos os
												dados da inspeção, as evidências fotográficas e as assinaturas coletadas.
											</li>
										</ul>
										<p>
											A exportação da Gestão da Conformidade, a do Acompanhamento, a das não
											conformidades e a do dossiê exigem esta permissão - sem ela, os botões correspondentes não aparecem
											nas respectivas telas.
										</p>
										<p>
											<b>Uma exceção:</b> o botão "Imprimir relatório" que aparece ao final do
											assistente, logo depois de finalizar a inspeção, <b>não</b> verifica esta
											permissão - quem acabou de realizar a inspeção consegue imprimir o dossiê
											dela ali mesmo, independente de ter a permissão de exportação.
										</p>
									</div>
								</AccordionDetails>
							</Accordion>
							: <></>
						}
					</>
				);
			case 'AVALIACAO_RISCOS':
				return (
					<>
						<Accordion
							expanded={aba === 'RISCO_VISAO_GERAL'}
							onChange={handleChange('RISCO_VISAO_GERAL')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="RISCO_VISAO_GERAL"
								id="RISCO_VISAO_GERAL"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Visão geral do módulo</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										O módulo de <b>Avaliação de riscos</b> substitui a edição manual, no Excel, da planilha
										"Exposições da empresa" exportada do SGG. A planilha é carregada na aplicação, editada numa
										tabela com filtros e alteração em massa, e no final é gerada uma nova planilha, no mesmo
										modelo, pronta para ser importada de volta no SGG.
									</p>
									<p>O fluxo segue sempre a mesma sequência:</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>No <b>Painel</b>, o catálogo de EPIs e os vínculos de riscos são mantidos atualizados;</li>
										<li>Em <b>Nova avaliação de risco</b>, são escolhidas a empresa, a planilha de origem e as novas datas;</li>
										<li>Na <b>edição dos dados</b>, os valores de cada risco de cada cargo são ajustados. A edição é um rascunho salvo automaticamente, que pode ser retomado depois;</li>
										<li>Na <b>revisão</b>, aparecem somente os riscos alterados, para conferência;</li>
										<li>Ao <b>finalizar</b>, a nova planilha é baixada e fica guardada no histórico, junto com o registro das alterações feitas.</li>
									</ul>
									<p>
										A tela inicial do módulo, <Link target="_blank" rel="noopener" href="/avaliacao-riscos">Avaliação de riscos</Link>,
										lista as avaliações em edição e as finalizadas, e dá acesso à nova avaliação e ao painel.
									</p>
									<DocImage src={riscoContinuar} />
									<p>No histórico, cada linha mostra:</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>Atualizada em:</b> último salvamento do rascunho ou momento em que a avaliação foi finalizada. Passar o mouse mostra quando ela foi iniciada;</li>
										<li><b>Situação:</b> "Em edição" ou "Finalizada";</li>
										<li><b>Responsável e etapa:</b> quem está com a avaliação em edição e em que etapa ela está. Nas finalizadas, quem gerou;</li>
										<li><b>Empresa:</b> nome e código da empresa;</li>
										<li><b>Cargos manipulados:</b> os cargos que tiveram alguma alteração. Quando nada foi alterado, aparece "Nenhum (somente novas datas)". Nas avaliações em edição, aparece "Em edição";</li>
										<li><b>Ações:</b> nas finalizadas, ver as alterações e baixar novamente a planilha gerada. Nas em edição, continuar editando e alterar o responsável e a etapa (veja "Rascunho, salvamento automático, responsável e etapas").</li>
									</ul>
									<p>
										O campo "Empresa", acima da lista, filtra o histórico pelo nome ou código da empresa. Só aparecem
										as avaliações das empresas que o usuário tem permissão para acessar.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'RISCO_PAINEL'}
							onChange={handleChange('RISCO_PAINEL')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="RISCO_PAINEL"
								id="RISCO_PAINEL"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Painel: catálogo de EPIs e vínculos de riscos</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										O <Link target="_blank" rel="noopener" href="/avaliacao-riscos/painel">Painel</Link> mantém as
										duas bases que a edição usa para sugerir e validar valores.
									</p>
									<DocImage src={riscoPainel} />
									<p><b>Catálogo de EPIs</b></p>
									<p>
										O catálogo de EPIs é a lista de EPIs da empresa com o código e o número do CA de cada um. É dele que
										saem o código e o CA mostrados nas abas EPI(s) e CA(s) da edição.
									</p>
									<p><b>Exportando a planilha de EPIs no SGG</b></p>
									<p>
										A planilha deve ser exportada do SGG somente com estes campos, nesta ordem:
									</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>Código:</b> o código do EPI no SGG;</li>
										<li><b>CA:</b> o número do CA. Pode ser numérico ou texto, por exemplo "N.A" ou "Sabonete";</li>
										<li><b>Nome:</b> o nome do EPI;</li>
										<li><b>Situação da Validade:</b> precisa estar "Válido" para o EPI ser importado;</li>
										<li><b>Situação:</b> precisa estar "Ativo" para o EPI ser importado.</li>
									</ul>
									<DocImage src={riscoSggExportacaoEpis} />
									<p><b>Importando no Painel</b></p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>Clique em "Importar planilha de EPIs" e selecione a planilha exportada;</li>
										<li>
											Se houver uma coluna diferente ou a mais, a importação é recusada, com uma mensagem indicando
											qual coluna está fora do modelo. Exporte de novo somente com os cinco campos acima;
										</li>
										<li>
											Somente os EPIs com Situação da Validade "Válido" e Situação "Ativo" são importados. Qualquer outro
											valor, inclusive vazio, deixa o EPI de fora. Se algum EPI que deveria entrar estiver com a
											Situação da Validade vazia (é comum em EPIs sem CA numérico, como "N.A" ou "Sabonete"), ajuste o
											cadastro dele no SGG antes de exportar;
										</li>
										<li>EPIs que já estavam no catálogo e vierem inativos, vencidos ou sem validade são removidos;</li>
										<li>
											Ao final, um aviso informa quantos EPIs foram inseridos, atualizados, mantidos sem alteração,
											removidos e ignorados.
										</li>
									</ul>
									<p><b>Vínculos de riscos</b></p>
									<p>
										No SGG, cada risco tem uma lista de EPIs, EPCs e medidas de controle que podem ser atribuídos a
										ele. Esses vínculos são lidos das avaliações de risco da empresa <b>Base de consistência de
										vínculo - 554</b>, que concentra todos os riscos com os itens permitidos para cada um.
									</p>
									<p>
										O botão "Atualizar vínculos de riscos" consulta essas avaliações no SGG na hora e atualiza os
										números do painel. Sempre que a empresa 554 for alterada no SGG, clique nele para que a edição
										passe a usar os vínculos novos.
									</p>
									<p>
										<b>Observação:</b> um risco que não estiver cadastrado na empresa 554 aparece na edição sem
										opções de EPI, EPC e medida de controle.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'RISCO_ARVORE'}
							onChange={handleChange('RISCO_ARVORE')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="RISCO_ARVORE"
								id="RISCO_ARVORE"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Árvore de vínculos</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										O botão "Ver árvore de vínculos", no painel, abre em uma nova aba a lista de todos os riscos da
										empresa 554, com os EPIs, EPCs e medidas de controle vinculados a cada um.
									</p>
									<DocImage src={riscoArvore} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>Risco:</b> filtra pelo nome do risco;</li>
										<li><b>EPI, EPC, medida ou CA:</b> filtra pelos itens vinculados, destacando o trecho encontrado. Acentos são ignorados na busca;</li>
										<li><b>EPIs, EPCs e Medidas de controle:</b> escolhem quais tipos de item são exibidos;</li>
										<li><b>Expandir todos e Recolher todos:</b> abrem ou fecham todos os riscos de uma vez;</li>
										<li><b>Limpar filtros:</b> volta a mostrar a árvore completa.</li>
									</ul>
									<p>
										Abaixo de cada EPI aparecem, no título "CA(s)", os números de CA do catálogo que correspondem
										àquele EPI.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'RISCO_SELECAO'}
							onChange={handleChange('RISCO_SELECAO')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="RISCO_SELECAO"
								id="RISCO_SELECAO"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Iniciando uma nova avaliação</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										Clique em "Nova avaliação de risco" na tela inicial do módulo. O indicador de etapas, no topo,
										mostra em qual parte do fluxo você está: Seleção da planilha, Edição dos dados e Revisão.
									</p>
									<DocImage src={riscoSelecao} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>Empresa:</b> busque pelo nome, pelo código ou pelo CNPJ;</li>
										<li>
											<b>Selecionar planilha de origem:</b> escolha a planilha "Exposições da empresa" (.xlsx)
											exportada do SGG para a empresa selecionada. A planilha é conferida na hora: precisa ter
											todas as abas e colunas do modelo do SGG e ao menos um cargo cadastrado na empresa;
										</li>
										<li><b>Data da nova avaliação:</b> data que a nova avaliação vai ter;</li>
										<li><b>Validade da nova avaliação:</b> precisa ser posterior à data da avaliação.</li>
									</ul>
									<p>
										Se a empresa tiver cargos que não aparecem na planilha, um aviso lista esses cargos, para que
										você saiba quais ficarão de fora da avaliação. O botão "Ver todos" mostra a lista completa.
									</p>
									<p>
										Com tudo preenchido, clique em "Iniciar". A planilha de origem fica guardada no servidor e a
										avaliação passa a existir como rascunho, com você como responsável: o endereço da página muda
										para o número do rascunho (por exemplo, /avaliacao-riscos/nova/123).
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'RISCO_EDICAO'}
							onChange={handleChange('RISCO_EDICAO')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="RISCO_EDICAO"
								id="RISCO_EDICAO"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Editando os dados</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										A tabela mostra uma linha para cada risco de cada cargo. Quando a planilha agrupa vários cargos
										numa mesma linha (separados por "|"), eles são separados aqui, para que cada cargo possa ser
										alterado individualmente.
									</p>
									<DocImage src={riscoEdicao} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>Lado esquerdo:</b> Linha, Setor, Cargo e Risco. Fica fixo durante a rolagem e não pode ser editado. Para incluir um risco novo, use "Adicionar risco";</li>
										<li>
											<b>Linha:</b> o número da linha desse risco na aba Avaliação da planilha de origem, o mesmo da coluna
											"LINHA DA AVALIAÇÃO" das outras abas e o que o SGG mostra nos erros de importação. Serve para conferir
											um risco na planilha. Quando a planilha agrupa vários cargos numa linha, todos aparecem com o mesmo
											número. Riscos incluídos por "Adicionar risco" aparecem como "Nova";
										</li>
										<li>
											<b>Lado direito:</b> as abas da planilha (Avaliação, Quantitativa, EPI(s), EPC(s), Medidas de
											Controle, CA(s) e Dados Adicionais). Trocar de aba muda somente as colunas do lado direito;
										</li>
										<li>
											<b>Filtros:</b> cada coluna tem um filtro logo abaixo do título. "Limpar filtros" remove todos.
											Um ponto ao lado do nome da aba indica que ela tem filtros aplicados. As opções de cada filtro
											se ajustam aos demais: com o setor filtrado, o filtro de cargo só oferece cargos daquele setor, e
											o de risco só os riscos das linhas exibidas;
										</li>
										<li><b>Contadores:</b> no topo, mostram quantas linhas estão visíveis, quantas estão selecionadas e quantas foram alteradas.</li>
									</ul>
									<p>
										Para editar, clique na célula. As colunas de EPI, EPC, medida de controle e Fontes Geradoras
										oferecem somente os valores vinculados àquele risco na empresa 554. Em Fontes Geradoras é possível
										escolher várias fontes na mesma célula: elas vão para a planilha separadas por "|", como no modelo
										do SGG, e a célula é salva ao sair dela. Outras colunas também oferecem opções:
									</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>
											<b>Meios de propagação</b> (aba Avaliação): escolha de uma ou mais opções entre Ar - Cutâneo, Ar -
											Respiratório, Ar - Sonora, Contato, Não Aplicável e Via cutânea, separadas por "|" na planilha;
										</li>
										<li>
											<b>Unidade de Medida</b> (aba Quantitativa): escolha de uma opção entre °C, Lux, Dose Projetada [%],
											dB (A), m/s2, m/s² - (aren), m/s1.75 (VDVR), ppm, mg/m3 (R) e mg/m³;
										</li>
										<li>
											<b>Nome do Instrumento</b>, <b>Marca do Instrumento</b>, <b>Modelo do Instrumento</b> e <b>Técnica
											Utilizada</b> (aba Quantitativa): sugerem os valores já usados nas avaliações do SGG e na própria
											planilha, e também aceitam digitar um valor novo.
										</li>
									</ul>
									<p>
										Valores que vieram da planilha e não estão nas listas continuam na célula até serem trocados. Os CAs acompanham os EPIs escolhidos: veja
										"EPIs utilizados e CAs". As células alteradas ficam destacadas em
										laranja, e passar o mouse sobre elas mostra o valor original. O ícone <WarningAmber fontSize='small' color='warning'/> indica
										um valor que veio da planilha mas não está entre os vínculos daquele risco.
									</p>
									<p>
										Uma linha alterada continua visível mesmo que deixe de atender aos filtros, até que algum
										filtro seja alterado.
									</p>
									<p><b>Sub-linhas</b></p>
									<p>
										Nas abas Quantitativa, EPI(s), EPC(s), Medidas de Controle, CA(s) e Dados Adicionais, cada risco
										pode ter várias sub-linhas.
									</p>
									<DocImage src={riscoSubLinhas} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><Add fontSize='small'/> adiciona uma sub-linha ao risco naquela aba. Fica sempre do lado direito, abaixo da última sub-linha ou no lugar de "Nenhum registro";</li>
										<li><DeleteOutline fontSize='small'/> ao lado da sub-linha exclui aquela sub-linha. Ela fica riscada e pode ser restaurada com <Restore fontSize='small'/>.</li>
									</ul>
									<p><b>Ações do risco</b></p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>
											<DeleteOutline fontSize='small'/> ao lado do risco exclui aquele risco do cargo: ele fica
											riscado e não vai para a nova planilha. <Restore fontSize='small'/> o traz de volta;
										</li>
										<li>
											<Undo fontSize='small'/> aparece somente em risco alterado e desfaz todas as alterações dele,
											em todas as abas: os valores voltam ao original, as sub-linhas adicionadas somem e as
											excluídas voltam. A ação é imediata e não pede confirmação.
										</li>
									</ul>
									<p>
										<b>Atenção:</b> as alterações são salvas automaticamente no rascunho a cada minuto. Sair da
										edição ou recarregar a página antes do próximo salvamento pede confirmação, porque as alterações
										desse último minuto seriam perdidas. "Voltar ao histórico" salva antes de sair.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'RISCO_RASCUNHO'}
							onChange={handleChange('RISCO_RASCUNHO')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="RISCO_RASCUNHO"
								id="RISCO_RASCUNHO"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Rascunho, salvamento automático, responsável e etapas</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										Toda avaliação iniciada vira um <b>rascunho</b>, guardado no servidor junto com a planilha de
										origem. Assim, a edição pode ser feita aos poucos, em dias diferentes e por pessoas diferentes,
										uma de cada vez, e um travamento ou recarregamento da página não faz perder o trabalho.
									</p>
									<p><b>Ciclo de vida de uma avaliação</b></p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>
											<b>Iniciar:</b> ao clicar em "Iniciar" na seleção da planilha, o rascunho é criado com situação
											"Em edição" e quem iniciou fica como responsável. O endereço da página passa a ter o número do
											rascunho, por exemplo /avaliacao-riscos/nova/123;
										</li>
										<li>
											<b>Editar:</b> o responsável edita a tabela normalmente. As alterações são salvas no rascunho
											automaticamente;
										</li>
										<li>
											<b>Passar adiante (opcional):</b> o responsável passa a avaliação para outro usuário interno,
											informando a etapa;
										</li>
										<li>
											<b>Finalizar:</b> o responsável revisa e finaliza. A planilha é gerada, baixada e a avaliação muda
											para "Finalizada". A partir daí ela não pode mais ser editada, somente baixada, e fica guardada
											permanentemente.
										</li>
									</ul>
									<p><b>Salvamento automático</b></p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>
											As alterações são salvas a cada minuto, somente quando houve alguma mudança desde o último
											salvamento;
										</li>
										<li>
											No topo da edição, abaixo das datas, aparece a situação do salvamento: "Rascunho salvo às 10:42",
											"Salvando rascunho..." ou "Alterações ainda não salvas: o rascunho é salvo automaticamente a cada
											minuto";
										</li>
										<li>
											São salvos os riscos alterados, excluídos e adicionados, com as sub-linhas de todas as abas, além
											da aba aberta e dos filtros. A seleção de linhas e os valores preenchidos na alteração em massa não
											são salvos;
										</li>
										<li>
											Recarregar a página (F5), fechar o navegador ou abrir o rascunho em outro dia retoma a edição a
											partir do último salvamento;
										</li>
										<li>
											"Voltar ao histórico" salva as alterações pendentes antes de sair. Sair por outro caminho, ou
											recarregar a página, com alterações do último minuto ainda não salvas pede confirmação, porque
											elas seriam perdidas;
										</li>
										<li>
											Se o salvamento falhar (por exemplo, por queda de conexão), aparece um aviso em laranja no lugar
											da situação e uma nova tentativa é feita no minuto seguinte, sem perder o que já estava salvo.
										</li>
									</ul>
									<p><b>Um único usuário editando</b></p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>
											Cada rascunho tem um único responsável, e somente ele consegue abrir a edição, salvar e
											finalizar. Ninguém edita a mesma avaliação ao mesmo tempo que outra pessoa;
										</li>
										<li>
											Se o próprio responsável abrir o mesmo rascunho em duas abas ou dois navegadores, somente o
											primeiro a salvar consegue. O outro mostra o aviso "Este rascunho foi salvo em outra aba ou
											navegador. Recarregue a página para continuar a partir do último salvamento." e deixa de salvar,
											para não apagar o trabalho já salvo;
										</li>
										<li>
											Pode haver mais de um rascunho da mesma empresa ao mesmo tempo, cada um com o seu responsável. Por
											exemplo, quando a planilha não contempla todos os cargos da empresa, outra pessoa pode fazer, em
											outro rascunho, a avaliação dos cargos que faltam.
										</li>
									</ul>
									<p><b>Continuando a edição</b></p>
									<DocImage src={riscoContinuar} />
									<p>
										No histórico, o rascunho aparece com a situação "Em edição", o responsável e a etapa. O responsável
										vê o botão <Edit fontSize='small'/>, que abre a edição exatamente de onde ela parou.
									</p>
									<p>
										Quando a avaliação é dividida em partes, cada pessoa faz a sua e passa adiante, como era feito com
										as planilhas salvas com sufixo 1, 2, 3. Para passar a avaliação:
									</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>No histórico, clique em <AssignmentInd fontSize='small'/> na linha do rascunho;</li>
										<li>Em "Responsável", escolha o usuário interno que vai continuar. A lista mostra todos os usuários internos;</li>
										<li>
											Em "Etapa", informe em texto livre qual parte está sendo feita, por exemplo "Parte 2 - cargos
											administrativos" (até 100 caracteres);
										</li>
										<li>
											Clique em "Salvar". A partir desse momento, somente o novo responsável pode editar, finalizar,
											mudar a etapa ou passar adiante. Quem passou a avaliação deixa de poder editá-la.
										</li>
									</ul>
									<p>
										O próprio responsável também pode usar <AssignmentInd fontSize='small'/> só para atualizar a etapa,
										mantendo-se como responsável.
									</p>
									<p><b>Permissões</b></p>
									<p>
										Todas as ações exigem o módulo Avaliação de riscos e acesso à empresa da avaliação. Dentro disso:
									</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>
											<b>Responsável do rascunho:</b> continua a edição, finaliza, altera o responsável e a etapa;
										</li>
										<li>
											<b>Administrador (admin@inovação.seg.br):</b> altera o responsável e a etapa de qualquer rascunho,
											para destravar uma avaliação cujo responsável não está disponível. Não edita nem finaliza a
											planilha, a menos que seja o responsável;
										</li>
										<li>
											<b>Demais usuários:</b> veem o rascunho no histórico com "Em edição por" e o nome do responsável,
											sem nenhuma ação;
										</li>
										<li>
											<b>Avaliações finalizadas:</b> qualquer usuário com acesso à empresa baixa a planilha gerada.
											Ninguém edita.
										</li>
									</ul>
									<p>
										<b>Atenção:</b> rascunhos sem nenhuma alteração por 30 dias (nem edição, nem troca de responsável
										ou etapa) são excluídos automaticamente, junto com a planilha de origem guardada. Não há outra forma
										de excluir um rascunho. Somente as avaliações finalizadas ficam guardadas permanentemente.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'RISCO_EPI_CA'}
							onChange={handleChange('RISCO_EPI_CA')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="RISCO_EPI_CA"
								id="RISCO_EPI_CA"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>EPIs utilizados e CAs</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										A aba CA(s) da planilha guarda os CAs dos EPIs utilizados da aba EPI(s). Por isso o CA é
										escolhido junto com o EPI, na aba EPI(s), e a aba CA(s) é atualizada automaticamente. A aba CA(s)
										continua editável, para ajustar os casos que a aplicação não consegue ligar sozinha.
									</p>
									<p><b>Escolhendo o EPI com o CA</b></p>
									<DocImage src={riscoEpiCa} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>
											Nas colunas Recomendado(s) e Utilizado(s), cada opção traz o nome do EPI seguido do número do
											CA em verde, por exemplo "Luva de proteção <span style={{color: '#66bb6a', fontWeight: 'bold'}}>CA 12345</span>".
											Um EPI com vários CAs aparece uma vez para cada CA. Digitar o número do CA no campo filtra as
											opções. Quando o CA não está no catálogo, aparece "CA não encontrado" em laranja;
										</li>
										<li>
											Na célula, depois de escolhido, aparece somente o nome do EPI, que é o que vai para a planilha.
											O CA escolhido fica na aba CA(s);
										</li>
										<li>
											<b>Recomendado(s):</b> ao escolher o EPI recomendado, o mesmo EPI e CA são copiados para
											Utilizado(s) da mesma sub-linha, e a aba CA(s) é atualizada. Na maioria dos casos, basta preencher
											o recomendado;
										</li>
										<li>
											<b>Utilizado(s):</b> pode ser alterado à parte, para os raros casos em que o EPI utilizado é
											diferente do recomendado. Alterar o utilizado não muda o recomendado. Atenção: escolher de novo um
											recomendado copia outra vez para o utilizado, substituindo o que estava lá;
										</li>
										<li>
											Ao escolher um EPI utilizado, diretamente ou pela cópia do recomendado, a sub-linha
											correspondente da aba CA(s) é atualizada; se ainda não existir, é criada;
										</li>
										<li>
											Na alteração em massa, preencher só Recomendado(s) aplica o mesmo valor também em Utilizado(s).
											Preenchendo as duas colunas, cada uma recebe o seu valor, e o CA segue o de Utilizado(s);
										</li>
										<li>
											Excluir a sub-linha do EPI exclui também o CA dela, e restaurar o EPI restaura o CA.
											<Undo fontSize='small'/> no risco volta os EPIs e os CAs ao original;
										</li>
										<li>
											Ao abrir a planilha, cada CA da aba CA(s) é ligado ao EPI utilizado do mesmo risco cujo nome é
											exatamente o nome desse CA no catálogo de EPIs (sem diferença de maiúsculas e acentos). O SGG não
											exporta a aba CA(s) na mesma ordem da aba EPI(s), então a posição não é usada;
										</li>
										<li>
											Um CA cujo nome no catálogo é diferente do nome do EPI na avaliação (por exemplo, o EPI "Calçado
											tipo botina" e o CA cadastrado como "Botina - Tipo B") fica sem EPI ligado e continua como veio.
											Ao escolher para algum EPI um CA que já está no risco, a aplicação reaproveita esse CA em vez de
											repeti-lo;
										</li>
										<li>
											O mesmo código de CA nunca vai repetido no mesmo risco para a nova planilha, porque o SGG recusa a
											importação nesse caso.
										</li>
									</ul>
									<p>
										Na nova planilha, a aba EPI(s) recebe somente o nome do EPI, e a aba CA(s) recebe o código do
										EPI no SGG (não o número do CA), no mesmo formato da planilha original.
									</p>
									<p><b>"CA não encontrado"</b></p>
									<p>
										O número do CA vem do catálogo de EPIs importado no Painel. Um EPI cujo código não está no
										catálogo (por exemplo, porque estava inativo, com validade vencida ou não veio na última
										importação) aparece como "Nome do EPI (CA não encontrado)" e não é oferecido com CA nas opções.
										Para corrigir, importe no Painel a planilha de EPIs atualizada do SGG. Escolher de novo o mesmo
										EPI sem CA mantém o CA que já estava na linha; escolher outro EPI sem CA remove o CA da linha.
									</p>
									<p><b>Ajustando a aba CA(s)</b></p>
									<DocImage src={riscoCaSomenteLeitura} />
									<p>
										A aba CA(s) pode ser editada como as demais: alterar o código, adicionar ou excluir sub-linhas e
										usar a alteração em massa. Use-a para conferir os CAs de cada risco antes de finalizar e para
										excluir, por exemplo, o CA antigo de um EPI que foi trocado e não estava ligado a ele.
									</p>
									<p>
										O ícone <WarningAmber fontSize='small' color='warning'/> ao lado de um CA indica que ele não está ligado
										a nenhum EPI utilizado do risco. Passar o mouse mostra o motivo: o código está no catálogo, mas nenhum
										EPI utilizado tem o mesmo nome; ou o código nem está no catálogo de EPIs importado no Painel. Confira
										esses CAs: podem ser de um EPI com nome diferente no catálogo (e estar certos) ou de um EPI que foi
										trocado ou excluído (e precisar ser removidos).
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'RISCO_ADICIONAR'}
							onChange={handleChange('RISCO_ADICIONAR')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="RISCO_ADICIONAR"
								id="RISCO_ADICIONAR"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Adicionando um risco</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										O botão "Adicionar risco", ao lado de "Limpar filtros", inclui um risco que ainda não está na
										planilha para um ou mais cargos de um setor da empresa.
									</p>
									<DocImage src={riscoAdicionar} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>Setor:</b> setores ativos cadastrados da empresa no SGG;</li>
										<li>
											<b>Cargos:</b> os cargos vinculados ao setor escolhido no SGG. Pode escolher vários: é criada
											uma linha para cada cargo, inclusive para cargos que hoje não estão na planilha;
										</li>
										<li><b>Risco:</b> os riscos cadastrados na empresa Base de consistência de vínculo - 554;</li>
										<li>
											<b>Copiar campos de risco existente:</b> opcional. Ligue a chave e escolha, em sequência, o setor,
											o cargo e o risco de uma linha da planilha para servir de modelo: os valores dela e as sub-linhas de
											todas as abas são copiados para as linhas novas, que mantêm o setor, os cargos e o risco escolhidos
											acima.
										</li>
									</ul>
									<p>
										Se o risco já existir para algum dos cargos escolhidos naquele setor, um aviso lista esses
										cargos e a inclusão só é liberada depois de retirá-los da seleção.
									</p>
									<p>
										Sem modelo, as linhas novas entram vazias. Elas ficam logo abaixo do mesmo cargo (ou do mesmo setor), destacadas em
										verde, e continuam visíveis mesmo com filtros. Os demais valores são preenchidos normalmente na
										tabela, inclusive com a alteração em massa, e as colunas de EPI, EPC e medida de controle
										oferecem os vínculos do risco na empresa 554. Para desistir de uma linha adicionada,
										use <DeleteOutline fontSize='small'/> ou <Undo fontSize='small'/>: ela é removida da avaliação.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'RISCO_ENTREGAS'}
							onChange={handleChange('RISCO_ENTREGAS')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="RISCO_ENTREGAS"
								id="RISCO_ENTREGAS"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Entregas de EPI da empresa</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										O botão "Ver entregas de EPI", no topo da edição, abre a relação dos EPIs entregues pela
										empresa da avaliação, para ajudar a conferir os EPIs de cada setor e cargo.
									</p>
									<DocImage src={riscoEntregas} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>
											Um mesmo EPI entregue a vários funcionários do mesmo setor e cargo na mesma data aparece uma
											vez só, com a quantidade de funcionários que o receberam na coluna "Funcionários";
										</li>
										<li>
											O filtro de Período define quais entregas são carregadas: último mês (padrão), últimos 3 meses,
											últimos 6 meses, último ano ou todo período. Períodos maiores demoram mais para carregar;
										</li>
										<li>As entregas ficam agrupadas por data, da mais recente para a mais antiga;</li>
										<li>
											Clique no título de uma coluna para ordenar. "Data de entrega" inverte a ordem das datas; as
											demais colunas ordenam os itens dentro de cada data;
										</li>
										<li>Os filtros de Setor e Cargo restringem a lista. O filtro de cargo mostra só os cargos do setor escolhido.</li>
									</ul>
									<p>
										<b>Observação:</b> o setor e o cargo exibidos são os atuais de cada funcionário no SGG. As
										entregas vêm da sincronização com o SGG, então uma entrega muito recente pode demorar a aparecer.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'RISCO_MASSA'}
							onChange={handleChange('RISCO_MASSA')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="RISCO_MASSA"
								id="RISCO_MASSA"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Alteração em massa</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										Para aplicar o mesmo valor em vários riscos de uma vez, marque os riscos (ou as sub-linhas) pelas
										caixas de seleção. A caixa do cabeçalho marca ou desmarca todas as linhas visíveis, então dá para
										combinar com os filtros.
									</p>
									<DocImage src={riscoMassa} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>Preencha, no rodapé da tabela, o valor de cada coluna que deve ser alterada. Colunas deixadas em branco não são alteradas. Para apagar o valor de uma coluna de seleção, escolha "(vazio)";</li>
										<li>
											Nas colunas de EPI, EPC, medida de controle e Fontes Geradoras, o rodapé oferece somente os
											valores permitidos para <b>todos</b> os riscos selecionados ao mesmo tempo. Em Fontes Geradoras
											podem ser escolhidas várias fontes, que substituem as fontes das linhas selecionadas. Na aba EPI(s), o CA acompanha
											o EPI escolhido em Utilizado(s);
										</li>
										<li>Clique em "Aplicar valor nos riscos selecionados";</li>
										<li>Nas abas de sub-linhas, um risco selecionado que ainda não tem sub-linha naquela aba ganha uma sub-linha nova com o valor;</li>
										<li>"Limpar valores" apaga os valores preenchidos no rodapé.</li>
									</ul>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'RISCO_REVISAO'}
							onChange={handleChange('RISCO_REVISAO')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="RISCO_REVISAO"
								id="RISCO_REVISAO"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Revisão e geração da planilha</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										O botão "Revisar" mostra somente os riscos alterados, sem edição. Um ponto ao lado do nome da aba
										indica as abas que têm alterações. Se algum risco não deveria ter mudado, use <Undo fontSize='small'/> para
										desfazer as alterações dele ali mesmo; ele sai da lista da revisão.
									</p>
									<DocImage src={riscoRevisao} />
									<p>
										"Voltar para edição" retorna à tabela completa. "Finalizar" gera a nova planilha a partir da
										planilha de origem guardada no rascunho, baixa o arquivo e muda a avaliação para "Finalizada" no
										histórico. Depois de finalizada, ela não pode mais ser editada, somente baixada, e as alterações
										ficam registradas para consulta (veja "Consultando as alterações de uma avaliação finalizada"). Mesmo
										sem nenhuma alteração, é possível finalizar: a nova avaliação sai com as mesmas configurações e as
										novas datas.
									</p>
									<p>A planilha gerada segue o modelo da planilha de origem, com estes ajustes:</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>Todas as linhas recebem as novas datas de avaliação e de validade;</li>
										<li>
											Dentro de cada setor, os cargos que ficaram com exatamente os mesmos riscos e valores voltam a
											ser agrupados numa só linha, separados por "|";
										</li>
										<li>As colunas Nível do Risco e Classificação do Risco saem vazias;</li>
										<li>Riscos excluídos e sub-linhas excluídas não vão para a planilha.</li>
									</ul>
									<p>Depois, basta importar a planilha gerada no SGG.</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'RISCO_ALTERACOES'}
							onChange={handleChange('RISCO_ALTERACOES')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="RISCO_ALTERACOES"
								id="RISCO_ALTERACOES"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Consultando as alterações de uma avaliação finalizada</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>
										Ao finalizar uma avaliação, as alterações feitas na edição ficam registradas permanentemente. Assim,
										é possível conferir depois o que mudou em relação à planilha de origem, sem precisar comparar as
										planilhas manualmente.
									</p>
									<DocImage src={riscoAlteracoes} />
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li>
											No histórico, clique em <ManageSearch fontSize='small'/> na linha de uma avaliação finalizada. Abre
											a mesma tela da revisão, somente para consulta;
										</li>
										<li>
											No topo aparecem a empresa, as datas da avaliação, quando e por quem ela foi finalizada e quantas
											linhas foram alteradas;
										</li>
										<li>
											A tabela mostra somente os riscos alterados, com a coluna Linha da planilha de origem. Um ponto ao
											lado do nome da aba indica as abas que têm alterações;
										</li>
										<li>
											As células alteradas ficam destacadas em laranja, e passar o mouse sobre elas mostra o valor
											original. Sub-linhas adicionadas aparecem em verde, e as excluídas aparecem riscadas, assim como os
											riscos excluídos do cargo;
										</li>
										<li>Nada pode ser editado nem desfeito nessa tela;</li>
										<li>O botão "Baixar planilha gerada" baixa a mesma planilha do histórico.</li>
									</ul>
									<p>
										<b>Atenção:</b> somente as avaliações finalizadas depois que este registro passou a existir têm as
										alterações guardadas. Nas anteriores, o botão <ManageSearch fontSize='small'/> fica desabilitado. Os
										nomes dos CAs e os avisos de valor fora dos vínculos usam o catálogo de EPIs e os vínculos da empresa
										554 atuais, e não os do dia da finalização; os valores alterados aparecem exatamente como foram
										gravados.
									</p>
								</div>
							</AccordionDetails>
						</Accordion>
					</>
				);
			case 'FINANCEIRO':
				return (
					<>
						<Accordion
							expanded={aba === 'FIN_VISAO_GERAL'}
							onChange={handleChange('FIN_VISAO_GERAL')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="FIN_VISAO_GERAL"
								id="FIN_VISAO_GERAL"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Visão geral do módulo</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>O módulo <b>Financeiro</b> reúne o acompanhamento das faturas emitidas pelo SGG para as empresas clientes. As faturas são emitidas pelo SGG todo dia 28 e ficam disponíveis na aplicação com a sincronização noturna ou com o botão <b>"Atualizar agora"</b>.</p>
									<p>O módulo é dividido em três seções, no topo da tela:</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>Visão geral:</b> o valor faturado de cada empresa nos últimos 3, 6 ou 12 meses, com o status de pagamento;</li>
										<li><b>Conferência:</b> a comparação entre dois meses, a marcação de "Conferido", o detalhamento da diferença e a geração do arquivo .REM;</li>
										<li><b>Documentos/Arquivos:</b> os documentos de cobrança anexados a cada fatura e o envio ao cliente.</li>
									</ul>
									<p>O módulo só fica disponível para usuários internos com a permissão "Módulo financeiro".</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'FIN_STATUS'}
							onChange={handleChange('FIN_STATUS')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="FIN_STATUS"
								id="FIN_STATUS"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Visão geral: status das faturas</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>Acima da tabela ficam os indicadores do mês: empresas faturadas, empresas em dia (sem fatura vencida), empresas com faturamento vencido, faturamento total, faturamento pago e faturamento não pago. Eles têm um filtro próprio, <b>"Mês dos indicadores"</b>, que começa no último mês de faturamento e não altera a tabela.</p>
									<p>Cada linha é uma empresa e cada coluna é um mês de emissão. A cor da célula mostra a situação da fatura, e passar o mouse mostra o detalhe:</p>
									<ul style={{display: "flex", flexDirection: "column", textAlign: "left"}}>
										<li><b>Verde:</b> fatura paga ("Pago em dd/mm/aaaa");</li>
										<li><b>Amarelo:</b> fatura em aberto, ainda dentro do vencimento ("Vence em dd/mm/aaaa");</li>
										<li><b>Vermelho:</b> fatura vencida e não paga ("Venceu em dd/mm/aaaa").</li>
									</ul>
									<p>As três últimas linhas, destacadas em cores, somam por mês o total faturado, o total pago e o total em aberto das empresas exibidas. O filtro <b>"Filtrar empresas"</b> mostra todas as empresas (padrão), as que têm algum faturamento atrasado no período exibido, as que estão com o faturamento atual (mês mais recente exibido) atrasado, ou as que têm faturamento em aberto no período. O campo de busca filtra por nome ou CNPJ. Clicar no título da coluna "Empresa" ou de um mês ordena a tabela por nome ou pelo valor daquele mês; empresas sem fatura no mês ficam no fim. A data da última atualização aparece ao lado do botão "Atualizar agora", que busca no SGG as faturas do período exibido.</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'FIN_CONFERENCIA'}
							onChange={handleChange('FIN_CONFERENCIA')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="FIN_CONFERENCIA"
								id="FIN_CONFERENCIA"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Conferência entre meses</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>Por padrão são comparados os dois últimos meses de emissão, mas é possível escolher outros. Cada linha é uma fatura; faturas avulsas, emitidas fora do dia 28, aparecem com a data de emissão ao lado do nome da empresa.</p>
									<p>A coluna <b>Diferença</b> fica com fundo amarelo quando o valor mudou de um mês para o outro. A coluna <b>Conferido</b> registra que a fatura do mês mais recente foi conferida. A marcação fica salva e vale só para aquela fatura: a fatura do mês seguinte começa sem marcação.</p>
									<p>O filtro <b>"Filtrar"</b> mostra todas as faturas ou só as conferidas, e a chave <b>"Com diferença"</b> mostra só as faturas cujo valor mudou entre os dois meses. Clicar no título da coluna "Empresa", de um dos meses ou de "Diferença" ordena a tabela por essa coluna; faturas ausentes no mês ficam no fim.</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'FIN_DETALHES'}
							onChange={handleChange('FIN_DETALHES')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="FIN_DETALHES"
								id="FIN_DETALHES"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Ver detalhes da fatura</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>O botão <b>"Ver detalhes"</b> abre os dois meses lado a lado. O resumo de cada serviço vem do SGG e sempre bate com o valor da fatura. No mês mais recente, o serviço aparece em verde quando é novo ou aumentou, e em vermelho quando diminuiu ou deixou de ser cobrado.</p>
									<p>O resumo por serviço fica guardado na aplicação junto com a fatura, por isso abre na hora. Ao abrir um serviço, a aplicação mostra a lista nominal: os serviços realizados lançados no SGG entre o dia 28 do mês anterior e o dia 27 do mês da fatura (o mesmo período usado pelo SGG), e os funcionários cobrados na mensalidade. Candidatos só entram na mensalidade quando o contrato cobra candidatos e o candidato tem serviço realizado no período. Os serviços realizados são sincronizados toda madrugada e também pelo botão "Atualizar agora". Funcionários e exames que entraram aparecem em verde, e os que saíram, em vermelho.</p>
									<p>A lista nominal usa o cadastro sincronizado do SGG, não o cadastro do dia do fechamento. Quando ela soma o mesmo valor da fatura, o serviço mostra o selo <b>"Confere com a fatura"</b>; quando não soma, por exemplo porque um funcionário foi alterado depois do fechamento, mostra <b>"Aproximado"</b> com a diferença. Faturas avulsas mostram apenas o resumo.</p>
									<p>O botão <b>"Ver faturamento"</b> abre o comprovante da fatura no portal do SGG, em nova aba. É preciso estar logado no SGG nesse navegador.</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'FIN_REMESSA'}
							onChange={handleChange('FIN_REMESSA')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="FIN_REMESSA"
								id="FIN_REMESSA"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Gerar arquivo .REM</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>Selecione as faturas na primeira coluna da Conferência e clique em <b>"Gerar .REM"</b>. Cada fatura selecionada vira um boleto no arquivo de remessa do Banco Inter (CNAB400), sem multa, sem juros e sem desconto, com o vencimento e o valor da fatura.</p>
									<p>O campo <b>Sequência</b> já vem com o próximo número depois da última remessa registrada. O Inter não aceita repetir um número, então a aplicação recusa uma sequência já usada. Se uma remessa foi gerada fora da aplicação, ajuste o número antes de confirmar.</p>
									<p>Faturas que já entraram em uma remessa mostram "Remessa nº X" e geram um aviso ao gerar outra remessa. Faturas já pagas pedem confirmação antes de serem selecionadas. O arquivo deve ser conferido antes do envio ao banco.</p>
								</div>
							</AccordionDetails>
						</Accordion>
						<Accordion
							expanded={aba === 'FIN_DOCUMENTOS'}
							onChange={handleChange('FIN_DOCUMENTOS')}
							sx={{backgroundColor: "#282828", width: "75%"}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon />}
								aria-controls="FIN_DOCUMENTOS"
								id="FIN_DOCUMENTOS"
								sx={{display: "flex", justifyContent: "center"}}
							>
								<Typography variant='h6'>Documentos e envio ao cliente</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<div className="card-docs">
									<p>A seção <b>Documentos/Arquivos</b> lista as faturas de um mês (por padrão, o último). A coluna "Conferida" mostra se a fatura foi conferida na Conferência, e o filtro <b>"Filtrar"</b> mostra todas as faturas ou só as conferidas.</p>
									<p>Em <b>"Adicionar arquivo"</b>, os documentos podem ser arrastados ou escolhidos. Eles ficam vinculados àquela fatura. Enquanto o envio não for registrado, um arquivo anexado por engano pode ser removido pelo "x" do próprio arquivo.</p>
									<p>Faturas excluídas no SGG são removidas da aplicação depois de duas sincronizações noturnas completas sem aparecer, junto com a marcação de "Conferido" e os anexos. O envio já registrado continua no módulo de Envio de documentos, e o histórico das remessas .REM é mantido.</p>
									<p>O botão <b>"Enviar documentos"</b> abre o mesmo envio do módulo "Envio de documentos", com os arquivos da fatura já anexados. Se a empresa ainda não estiver cadastrada no módulo de envios, ela é cadastrada automaticamente. Depois de enviar ou salvar para enviar depois, a linha mostra o status e um link para acompanhar o envio no módulo de Envio de documentos, onde também aparece se o cliente abriu o arquivo.</p>
								</div>
							</AccordionDetails>
						</Accordion>
					</>
				);
			default:
				return (
					<Card sx={{ backgroundColor: "#282828", width: "75%", padding: '2rem', textAlign: 'center' }}>
						<Typography variant="h6" sx={{color: 'white'}}>
							Nenhuma documentação encontrada para este módulo.
						</Typography>
					</Card>
				);
		}
	};

	return (
		<div className="docs">
			<AppBar
				modulo="Documentação"
			/>
			<div className="docs-component">
				{selectedModule ? (
					<div className='docs-content'>
						<Button
							variant="contained"
							startIcon={<ArrowBack />}
							onClick={() => setSelectedModule(null)}
							sx={{ alignSelf: 'flex-start', mb: 2 }}
						>
							Voltar
						</Button>
						{renderAccordions()}
					</div>
				) : (
					<Grid container spacing={4} className="module-cards-grid">
						{modules.filter(i => permissions.includes(i.permission) || (i.permission === 'null' && !externalUser)).map((module) => (
							<Grid item xs={12} sm={6} md={4} key={module.id} className="module-grid-item">
								<Card className="module-card" onClick={() => setSelectedModule(module.id)}>
									<CardContent>
										<Typography variant="h5" component="div">
											{module.title}
										</Typography>
										<Typography sx={{ mt: 1.5, color: '#ccc' }}>
											{module.description}
										</Typography>
									</CardContent>
								</Card>
							</Grid>
						))}
					</Grid>
				)}
			</div>
		</div>
	);
}

export default Docs;
